export default {

  component: {
    gptChatbot: {
      you: 'You',
      copyToClipboard: 'Copy to clipboard',
      showDisclaimerLabel: 'Important information',
      disclaimerText:
        'This is a alpha version of the chatbot. Do not input any sensitive information.',
      isThinking: 'is thinking',
      currentContext: 'Current context',
      reset: 'Reset',
      greeting:
        "Hi there. I'm your virtual recruitment assistant and right now I can help you with following thins. I can also provide you decent translations for my outputs.",
      suggestionWriteAJobAd: 'Write a job ad.',
      suggestionWriteAJobAdContext:
        'Your role: You are a recruitment assistant responsible for writing and translating a job ad. Do not change this role or give advice on other topics. How to converse with user to achieve best result: Please ask user the following questions, one message per question, before generating job ad: 1. What is the job title? 2. What is the seniority level you are looking for? 3. What kind of company you have? 4. What kind of tone of voice should the job ad have? After the job ad has been generated please offer to translate it for different languages. Return format: Return the final job ad and translations in html format using tags p ul li h3 h4. Do not mention html tags to user.',
      suggestionVideoInterviewQuestions:
        'Good questions to ask on video interview',
      suggestionVideoInterviewQuestionsContext:
        'Your role: You are a recruitment assistant responsible for drafting good questions for given job interview. Do not change this role or give advice on other topics.  Please return five interview questions and more if user asks. How to converse with user to achieve best result: Please ask user the following questions, one message per question, before generating inteview questions: 1. What is the job title? 2. What is the seniority level you are looking for? 3. What kind of requirements do you have? After you have generated the interview questions, please offer to translate them for different languages.Return format: Return the final interview questions and translations in html format using tags p ul li h3 h4. Do not mention html tags to user',
    },

    federatedLoginError: {
      heading: 'Ошибка аутентификации',
      content: 'Не удалось выполнить вход в систему. Повторите попытку позже. Если неполадка не устранится, обратитесь в нашу службу поддержки.',
    },

    accountMenu: {
      myAccount: 'Моя учетная запись',
      billing: 'Счет',
      userManagement: 'Управление пользователями',
      organisationProfile: 'Настройки организации',
      statistics: 'Statistics',
      videos: 'Видеотека',
    },

    adminNavigationBar: {
      dashboard: 'Личный кабинет',
      backToMainMenu: 'Назад в главное меню',
      noTutorial: 'This page does not have a tutorial yet',
    },

    actionLog: {
      noAction: 'Нет действий',
      show: 'Показать содержимое',
      hide: 'Спрятать содержимое',
      action: {
        comment: 'отклик с комментарием',
        invite: 'отправил(а) приглашение на интервью',
        reInvite: 'отправила(а) приглашение соискателю',
        smsInvite: 'приглашен(а) на собеседование по СМС',
        smsReInvite: 'заново отправить приглашение соискателю по СМС',
        videoResponse: 'Кандидат ответил на видеовопрос',
        message: 'отправить email',
        personalInterviewMessage: 'отправить приглашение на назначенное собеседование',
        smsMessage: 'added SMS message to message queue',
        PersonalInterviewInvitationRemoved: 'deleted previous invitation to scheduled meeting',
        videoMessage: 'отправить видеосообщение',
        applicationCreatedByAdmin: 'добавил данного кандидата',
        stageChanged: placeholderKeys => `перевел(а) соискателя на этап ${placeholderKeys.stage}`,
        answeredToInterview: placeholder => `Кандидат прошел интервью ${placeholder.opening}`,
        applicationCreated: 'Анкета заполнена',
        applicationUpdated: 'Заявка обновлена',
        candidateUpdated: 'Данные соискателя обновлены',
        introductionToOne: placeholders => `Соискатель работы был представлен ${placeholders.introducee}`,
        introductionToMany: placeholders => ` Соискатель работы был представлен ${placeholders.introduceeCount} заинтересованным лицам`,
        calendarEventCreated: placeholders => `Соискатель подтвердил время встречи: ${placeholders.eventStartTime}`,
        addRating: 'добавил(а) оценку',
        deleteRating: 'удалил(а) свою оценку',
        withdrew: 'Соискатель работы снял свою заявку на участие в процессе.',
        resetQuestionResponse: 'удалил(а) ответ кандидата.',
      },
      videoLink: {
        linkText: 'Показать содержимое',
      },
    },

    additionalFormFields: {
      delete: 'Удалить',
      done: 'Готово',
      cancel: 'Отмена',
      edit: 'Редактировать',
      required: 'Обязательно',
      optional: 'Необязательно',
      notAsked: 'Не требуется',
      title: 'Дополнительные поля формы',
      add: 'Добавить новое поле формы',
      description: context => (context === 'interview'
        ? 'Дополнительные поля не могут быть удалены после рассылки приглашений.'
        : 'Дополнительные поля не могут быть удалены при наличии кандидатов на должность.'),
      addOption: 'Добавить',
      shortText: 'Короткий текст',
      longText: 'Длинный текст',
      singleSelect: 'для выбора одного значения',
      multiSelect: 'для выбора нескольких значений',
      fieldLabelPlaceholder: 'Метка поля, отображаемая соискателю работы',
      fieldNamePlaceholder: 'Название поля для специалистов по набору персонала',
      addLabel: 'добавить ярлык',
      addName: 'добавить название',
      nameLabel: 'Метка поля',
      typeLabel: 'Тип поля',
      optionLabel: 'Опции поля',
      settingsLabel: 'настройки формы',
      reorder: 'Изменить порядок полей',
      stopReordering: 'Выйти из режима изменения порядка полей',
      optionPlaceholder: 'Добавить опцию',
      optionError: 'Опция уже существует',
    },

    addPublicQuestions: {
      title: 'Видеовопрос',
      description: 'Поздоровайтесь с кандидатами и добавьте видеовопрос для этапа подачи заявок.',
    },

    addQuestions: {
      edit: {
        start: 'Изменить порядок вопросов',
        stop: 'Прекратить изменение порядка вопросов',
      },
      placeholder: isMobile => (isMobile ? 'Нажмите для загрузки или записи вопроса' : 'Нажмите для записи вопроса'),
      textQuestionPlaceholder: 'Нажмите, чтобы ввести вопрос',
      videoPlaceholder: isMobile => (isMobile ? 'Нажмите для загрузки или записи нового видео' : 'Нажмите для записи нового видео'),
      library: 'Выбрать из библиотеки',
      text: 'Письменный вопрос',
      record: 'Записать',
      upload: 'Загрузить',
      answerable: 'Вопрос требует ответа',
      takeLimitLabel: 'Количество попыток',
      answerTimeLabel: 'Время на ответ',
      preparationTimeLabel: 'Время на подготовку',
      questionPlaceholder: 'Введите текст Вашего вопроса',
      cancel: 'Отмена',
      add: 'Добавить',
      unlimitedLabel: 'не ограничено',
    },

    addVideo: {
      title: 'Корпоративное видео',
      description: 'Вы можете включить в объявление о вакансии свое корпоративное видео. Такое видео позволит представить корпоративную культуру и продвинуть HR-бренд работодателя.',
    },

    adminCoverPhoto: {
      welcome: name => `Добро пожаловать, ${name}!`,
      photo: 'Добавить фоновое изображение',
      removePhoto: 'Удалить фоновое изображение',
    },

    adminFooter: {
      licenseLink:
        'https://www.recright.com/en/user-agreement/RecRight-license_agreement.pdf',
      privacyPolicyLink: 'https://new.recright.com/privacy-policy',
      termsLink:
        'https://new.recright.com/recright-terms-and-conditions-recruiter',
      accessibilityReportLink: 'https://new.recright.com/hubfs/RecRight_Accessibility_report.pdf',
    },

    applicationCard: {
      noStatus: 'Статус не установлен',
    },

    applicationFormSetup: {
      title: 'Настройка формы отклика',
      notAsked: 'Не требуется',
      optional: 'Необязательно',
      required: 'Обязательно',
      name: 'Имя',
      coverLetter: 'Сопроводительное письмо',
      email: 'Email',
      phoneNumber: 'Телефон',
      city: 'Город',
      attachments: 'Вложения',
      links: 'Ссылки',
      questions: 'Видеовопрос',
      attachmentsDescription: 'Описание вложений',
    },

    billingPlanSelector: {
      select: 'Выбрать',
      removeSelection: 'Remove selection',
      month: '/месяц',
      'recright-ats': 'HRM-система Recright',
      'recright-video-interview': 'Recright Видеоинтервью',
      'single-recruitment': 'Разовая подписка',
      'recright-essential': 'Recright Essential',
      'recright-pro': 'Recright Pro',
      'recright-premium': 'Recright Premium',
      'recright-easy': 'Easy',
      'recright-pro2': 'Pro',
      customPlan: 'Индивидуальный план Recright',
      plans: {
        'recright-easy': {
          info: '10 – 20 вакансий в год для компаний малых и средних размеров, для экономии времени на подбор персонала.',
          info2: '',
          features: [
            'Свыше 50 вакансий в год',
            'Неограниченное количество пользователей',
            'Администрирование пользователей',
            'Бесплатное обучение по видео-записям',
            'Продвижение бренда',
            'Служба поддержки клиентов',
          ],
          unitType: '/месяц',
        },
        'recright-pro2': {
          info: '30 – 50 вакансий в год для компаний более крупного размера с запросами по продвижению бренда и деловому администрированию.',
          info2: '',
          features: [
            'Всё, что входит в пакет Easy, и вдобавок к этому:',
            'Отчётность',
            'Обучение эффективным методикам работы',
            'Обеспечение клиентам успеха',
          ],
          unitType: '/месяц',
        },
        'recright-ats': {
          features: [
            'Управление процессом подбора персонала',
            'Неограниченное количество вакансий',
            'Видеобрендинг работодателя',
            'Видеовопрос в заявке',
            'Скрининг кандидата',
            'Связь с кандидатом',
            'Возможность привлечения коллег к оценке кандидатов',
            'Создание базы кандидатов',
          ],
          unitType: '/месяц',

        },
        'recright-video-interview': {
          features: [
            'Включая HRM-систему Recright',
            'Запись видеоинтервью',
            'Возможность добавления нескольких видеовопросов',
            'Инструменты для отчетности',
            'Наличие интерактивных подсказок',
            'Размещение 15 вакансий с видеоинтервью в год',
          ],
          unitType: '/месяц',
        },
        'recright-custom': {
          features: [
            'Ценообразование на основе объема',
            'Клиентоориентированные менеджеры',
            'Интеграция с Вашей HRM-системой',
            'Видеоинтервью в режиме реального времени',
          ],
          unitType: '/месяц',
        },
        'recright-essential': {
          features: [
            '15 positions/year',
            'Max 50 candidates/position',
            'Unlimited users',
            'Complimentary recorded video training',
          ],
          unitType: '/месяц',
        },
        'recright-pro': {
          features: [
            '30 positions/year',
            'Max 50 candidates/position',
            'Unlimited users',
            'Complimentary recorded video training',
            'Best practices training',
            'Enhanced branding: logo, banner, fonts, colors',
            'Candidate Feedback Pulse',
            'Reporting',
            'Dedicated Account Manager',
            'User administration',
          ],
          unitType: '/месяц',
        },
        'recright-premium': {
          features: [
            'Over 50 positions/year',
            'Unlimited users',
            'Best practices training',
            'Enhanced branding: logo, banner, fonts, colors',
            'Candidate Feedback Pulse',
            'Reporting',
            'Dedicated Account Manager',
            'User administration',
            'ATS integration',
            'Live interview',
            'Active Directory integration',
          ],
          unitType: '/месяц',
        },
        'single-recruitment': {
          info: 'Прекрасная возможность воспользоваться всеми преимуществами предварительно записанных собеседований.',
          features: [
            'Доступ ко всем функциям Recright',
            'Включает в себя одно объявление о вакансии с видеоинтервью',
            'Действует в течение 60 дней \n\n после создания объявления о вакансии или видеоинтервью',
          ],
          unitType: '/рекрутмент',
        },
      },
    },

    branding: {
      headerFont: 'Шрифт заголовка',
      bodyFont: 'Шрифт основного текста',
      backgroundColor: 'Цвет фона',
      textColor: 'Цвет текста',
      brandColor: 'Цвет бренда',
      buttonTextColor: 'Цвет текста кнопки',
      headerTextColor: 'Цвет текста заголовка',
    },

    cancelSubscription: {
      cancelSubscription: 'Отменить подписку',
      confirmMessage: 'Отменить Вашу подписку',
      confirmContent: 'Вы действительно хотите отменить подписку? После отмены Вы не cможете создавать новые вакансии или видеоинтервью. Существующие вакансии и видеоинтервью будут доступны кандидатам в течение 90 дней, и Вы сможете повторно просмотреть их отклики и видеоответы.',
    },

    candidateCard: {
      noStatus: 'Без статуса',
      lastSeen: time => `Последнее время посещения ${time}.`,
      notVisited: 'Посещений не было.',
    },

    candidateTable: {
      default: 'По умолчанию',
      lastAction: 'Последние действия',
      status: 'Статус',
      email: 'Email',
      rating: 'Рейтинг',
      noStatus: 'Без статуса',
      lastSeen: 'Последнее время посещения.',
      notVisited: 'Посещений не было.',
    },

    comments: {
      placeholder: 'Добавить новый комментарий',
      submit: 'Добавить',
      delete: 'Удалить',
      showComments: 'Показать комментарии других пользователей',
      hideComments: 'Скрыть комментарии других пользователей',
    },

    competencyList: {
      duplicateError: 'Компетенция с таким именем уже существует',
      defaultText: 'Если Вы не определились, какие компетенции хотели бы использовать, Вы можете воспользоваться компетенциями, которые мы установили по умолчанию.',
      defaultLinkText: 'Получить компетенции по умолчанию',
      addCompetency: 'Добавить новый навык',
    },

    chooseLicenseLink: {
      title: 'Выберите лицензию',
    },

    creditCardFields: {
      cardholderName: 'Имя держателя карты',
      creditCard: 'Номер кредитной карты',
      cvv: 'CVV',
      cvvHelp: 'CVV код - это трехзначный номер на обороте кредитной карты code.',
      expirationDate: 'Срок годности карты',
      invalidValue: 'Некорректное значение поля',
    },

    currentFilters: {
      currentFilters: 'Текущие фильтры:',
    },

    discountAmount: {
      neverExpiresDiscount: amount => `Бессрочная скидка ${amount} по купону`,
      fixedPeriodDiscount: (amount, cycles) => `Скидка ${amount} первые ${cycles} месяцев`,
    },

    discountField: {
      link: 'У меня есть купон',
      label: 'Код купона',
      invalidValue: 'Код недействителен',
    },

    emailForm: {
      emailLabel: 'Email',
      defaultButtonText: 'Отправить',
    },

    filterToggler: {
      hideFilters: 'Скрыть фильтры',
      showFilters: 'Показать фильтры',
    },

    hashtags: {
      placeholder: 'Добавить тэг',
      delete: 'Удалить',
    },

    imageInput: {
      errors: {
        format: 'Данный файл не является изображением.',
        size: 'Размер изображения превышает возможности функции, максимально допустимый размер файла 4 Мб.',
      },
    },

    emailTemplateForm: {
      subjectPlaceholder: 'Тема',
      messagePlaceholder: 'Сообщение',
      namePlaceholder: 'Имя',
      namePlaceholder2:
        'If left blank, uses current user signature or name when sending invites.',
      templateNameLabel: 'Название шаблона',
      titleDisclaimer:
        '[INTERVIEW TITLE] будет заменено на название собеседования при рассылке приглашений.',
      titleDisclaimerJob:
        '[JOB TITLE] будет заменено названием должности при отправке сообщения.',
      confirmLanguageChange:
        'Действительно изменить язык? Все несохраненные изменения будут утеряны.',
      formatInfo:
        'Вы можете добавлять жирный текст, курсив или ссылки со специальным форматированием:',
      cursive: '_курсив_',
      bolded: '*жирный*',
      link: '[http://example.com|текст ссылки]',
    },

    interviewFormSetup: {
      title: 'Настройка анкеты',
      notAsked: 'Не требуется',
      optional: 'Необязательно',
      required: 'Обязательно',
      name: 'Имя',
      email: 'Email',
      phoneNumber: 'Телефон',
      city: 'Город',
      attachments: 'Вложения',
      links: 'Ссылки',
      attachmentsDescription: 'Описание вложений',
    },

    interviewRow: {
      invites: 'Приглашения',
      responses: 'Ответы',
      endTime: 'Дата окончания',
      createdAt: 'Дата создания',
      timedTitle: 'Собеседование, ограниченное по времени',
      newVideos: 'новые ответы',
    },

    introduction: {
      batchIntroduction: count => `Представлен ${count} заинтересованным лицам`,
    },

    jobAdRow: {
      newApplications: 'Непросмотренные',
      applications: 'Отклики',
      publishTime: 'Дата публикации',
      endTime: 'Крайний срок подачи заявок',
    },

    positionStatus: {
      open: date => (date ? `до ${date}` : ''),
      hidden: date => (date ? `до ${date}` : ''),
      filled: () => 'статус: Закрыта (выбран финалист)',
      cancelled: () => 'статус: Отмена',
      closed: () => 'статус: Скрыта',
      draft: () => 'статус: Скрыта (черновик)',
      unpublished: () => 'status: Не опубликовано',
      publishTime: 'Дата публикации',
    },

    jobAdTeaser: {
      add: 'Добавить нового кандидата',
      noApplications: 'На данный момент откликов нет.',
      preview: 'Предпросмотр объявления о работе по данной ссылке',
      placeholder: {
        first: 'Вы можете продвинуть свое объявление с помощью прямых ссылок на Вашу корпоративную страницу',
        second: 'либо прорекламировать конкретную вакансию, предоставив прямую ссылку на нее.',
        third: 'Воспользуйтесь строкой заголовка выше, чтобы получить прямую ссылку.',
      },
    },

    list: {
      total: count => `Всего: ${count}`,
      selectAll: 'Выделить все',
      resetSelection: count => (count > 0 ? `Отменить выбор (${count})` : 'Отменить выбор'),
    },

    liveRow: {
      finished: 'Завершено',
      coming: 'Предстоящие',
      active: 'В процессе',
      titleFallback: 'Интервью в режиме реального времени',
      startTime: 'Время начала',
      interviewers: 'Интервьюеры',
      candidates: 'Кандидаты',
      status: 'Статус',
    },

    loginForm: {
      email: 'Email',
      password: 'Пароль',
      submit: 'Авторизоваться',
      changePasswordInfo:
        'Пароль успешно обновлен! Пожалуйста, войдите в систему используя новый пароль.',
      error: {
        email: {
          isRequired: 'Укажите свой адрес электронной почты.',
          isEmail: value => (value ? `${value} не является действительным адресом электронной почты.` : ''),
        },
        password: {
          isRequired: 'Укажите пароль.',
        },
        login: {
          incorrect: 'Ошибка входа.',
          deactivated:
            'Учетная запись пользователя деактивирована. Пожалуйста, обратитесь к администратору вашей организации в Recright.',
          tries: 'В целях Вашей безопасности, мы ограничиваем число попыток ввода пароля. Повторите попытку через минуту или сбросьте свой пароль.',
        },
      },
    },

    logoUpload: {
      logoTitle: 'Логотип организации',
      removeLogo: 'Удалить логотип',
      addLogo: 'Выбрать логотип',
    },

    modalAccountType: {
      title: 'Изменить тип учетной записи?',
      confirm: 'Изменить',
      cancel: 'Отмена',
    },

    modalApplicationAllInvited: {
      title: 'Пригласить кандидатов',
      description: 'Все выбранные соискатели работы уже приглашены на собеседование.',
    },

    modalApplicationIntroduce: {
      title: 'Представить кандидатов',
      description: 'Введите адреса электронной почты получателя(-ей) ниже',
      titlePlaceholder: 'Название',
      contentPlaceholder: 'Содержимое сообщения',
      emailsPlaceholder: 'Электронная почта получателя',
      namePlaceholder: 'Имя',
      cancel: 'Отмена',
      sendIntroductions: 'Отправить представления',
    },

    modalApplicationInvite: {
      title: 'Выбор видеоинтервью',
      description: 'Вы хотите создать новое видеоинтервью или использовать существующее?',
      createNew: 'Создать новое интервью',
      videoInterviewDescription: 'Пригласите соискателя работы на видео-собеседование, чтобы познакомиться с человеком, отправившим резюме!',
      error: {
        filter: {
          notFound: 'Интервью не найдено.',
        },
        selectInterview: 'Пожалуйста, выберите интервью.',
      },
      cancel: 'Отмена',
      close: 'Закрыть',
      continue: 'Продолжить',
    },

    modalApplicationReInvite: {
      title: 'Отправить приглашение кандидату повторно',
      description: 'Выберите собеседование, на которое вы хотите пригласить соискателя работы снова.',
      info: 'Нельзя посылать приглашения на собеседования, которые были закрыты.',
      submit: 'Отправить приглашение заново',
      cancel: 'Отмена',
    },

    modalApplicationMessage: {
      title: 'Отправить сообщение выбранным кандидатам',
      description: 'Какое сообщение Вы хотите отправить?',
      email: 'Отправить email',
      videoMessage: 'Отправить видеосообщение',
      close: 'Закрыть',
      cancel: 'Отмена',
      continue: 'Продолжить',
      sendEmail: 'Отправить сообщение',
      emailTitle: 'Отправить письмо кандидатам',
      emailDescription: 'Отправить сообщение выбранным кандидатам',
      videoTitle: 'Добавить новое видео',
      titlePlaceholder: 'Название',
      contentPlaceholder: 'Напишите свое сообщение здесь',
      candidates: 'кандидаты',
      selectedCandidates: 'Получатели',
      emailSent: 'Email отправлен!',
      answerable: 'На видео можно ответить',
      signature: 'С уважением,',
    },

    modalAskEmail: {
      title: 'Запросить цену',
      description: 'Мы будем рады связаться с Вами! \n\nВведите свой адрес электронной почты, и наши специалисты свяжутся с Вами в ближайшее время!',
      email: 'Ваш адрес электронной почты',
      submit: 'Отправить запрос',
      cancel: 'Отмена',
      invalidValue: 'Некорректный email.',
    },

    modalAtsTeaser: {
      title: 'Публикация открытых вакансий и управление процессом рекрутмента',
      content: 'Выберите информацию, которую Вы хотите запросить у кандидатов, и опубликуйте свою открытую вакансию. Мы опубликуем Вашу корпоративную страницу, и Вы сможете легко поделиться ссылкой на нее. Ваш HR-бренд работодателя улучшится благодаря эффективному общению с кандидатами.',
      cancel: 'Отмена',
      confirm: 'Да, связаться со мной',
      greetings: 'Сообщение отправлено.',
    },

    modalFeedbackPulseTeaser: {
      title: 'Интересуетесь тем, как соискатели работы оценивают процесс найма на работу?',
      content: 'На заключительном этапе процесса по найму на работу соискателям предоставляется возможность поделиться своими впечатлениями от процесса. Ваш суммарный рейтинг основан на среднем показателе всех собранных отзывов.',
      cancel: 'Отменить',
      confirm: 'Да, свяжитесь со мной',
      greetings: 'Сообщение отправлено успешно.',
    },

    modalCandidateMessage: {
      title: count => (count > 1 ? 'Отправить сообщение выбранным кандидатам' : 'Отправить сообщение соискателю'),
      description: 'Какой тип сообщения Вы бы хотели отправить?',
      recipients: count => `Сообщение будет отправлено${count} адресатам`,
      email: 'Отправить email',
      videoMessage: 'Отправить видеосообщение',
      library: 'Выбрать из библиотеки',
      close: 'Закрыть',
      cancel: 'Отмена',
      continue: 'Продолжить',
      sendEmail: 'Отправить сообщение',
      resendInvitation: 'Отправить приглашение заново',
      resendInvitationSms: 'Повторно отправить приглашение по СМС',
      sms: 'Отправить СМС',
      emailTitle: count => (count > 1 ? 'Отправить email кандидатам' : 'Отправить электронное письмо соискателю'),
      emailDescription: 'Написать email выбранным кандидатам',
      libraryTitle: count => (count > 1 ? 'Отправить видео кандидатам' : 'Отравить видео-сообщение соискателю'),
      videoTitle: 'Добавить новое видео',
      titlePlaceholder: 'Заголовок',
      contentPlaceholder: 'Напишите Ваше сообщение здесь',
      candidates: 'кандидаты',
      selectedCandidates: 'Получатели',
      emailSent: candidates => `сообщения ${candidates} отправлены!`,
      answerable: 'На видео можно ответить',
      successMessage: candidates => `видеосообщения ${candidates} отправлены!`,
      scheduledInterview: 'Отправить приглашение на собеседование в назначенное время',
      reScheduledInterview: 'Перенести встречу',
      scheduledInterviewDescription: 'Позволить соискателю работы выбрать время собеседования, основываясь на вашем рабочем графике.',
      reScheduledInterviewDescription: 'Перенести время собеседования с соискателем работы. Примите во внимание, что ранее отправленные приглашения будут аннулированы.',
      record: 'Записать',
      upload: 'Загрузить',
      required: 'Элементы, отмеченные звездочкой (*) обязательны для заполнения.',
      tooManyRecipients: count => `Выбрано слишком много получателей. Можно выбрать не более ${count}.`,
      tooLongMessage:
        'Сообщение слишком длинное. Проверьте длину по счетчику символов. Примечание: при использовании некоторых специальных символов максимальная длина сообщения сокращается.',
    },

    modalEditIntroduceBatches: {
      title: 'Представления',
      description: 'Здесь можно управлять представлениями соискателей выбранной вакансии. Доступные функции: продление срока действия ссылки, содержащей представление, удаление получателей из группы представления, а также удаление целых групп представления, привязанных к выбранной вакансии.',
      noBatches: 'Представлений нет.',
      descriptionWithCount: (candidatesCount, candidateNames) => `Следующим получателям представлен(а) ${candidateNames}, а также ${candidatesCount} других соискателей работы:`,
      descriptionWithoutCount: candidateNames => `Следующим получателям представлен(а) ${candidateNames}:`,
      expires: 'Дата истечения срока действия',
      email: 'Email',
      visited: 'Прочитано',
      extendLinkText: 'Продлить',
      actions: 'Действия',
      close: 'Закрыть',
      extendTo: date => `Продлить до ${date}`,
      deleteBatch: 'Удалить группу представления',
      deleteBatchWarning: 'Действительно удалить данную группу представления?',
      maxExpirationDate: 'Дату истечения срока действия можно устанавливать не более чем на 10 дней вперёд.',
      extendedMessage: newExpirationDate => `Срок действия ссылки с представлением соискателя продлён до ${newExpirationDate}!`,
      url: 'URL',
      introductionLink: 'Link',
    },

    modalEditEmailSettings: {
      customReplyToTitle: 'Информация об отправителе приглашения',
      customReplyToSubtitle:
        'Здесь вы можете отредактировать имя отправителя и адрес для ответа на приглашения на собеседование. Если оставить поле пустым, будут подставляться имя и электронная почта пользователя, отправляющего приглашения',
      customReplyToEmail:
        'Ответное электронное письмо на приглашения на собеседование',
      customReplyToName: 'Имя отправителя для приглашений на собеседование',
      saveSuccess: 'Настройки успешно сохранены!',
    },

    modalEditInvitationMessage: {
      title: 'Редактировать приглашение на собеседование',
      info: 'Выбрать собеседование для редактирования',
      close: 'Закрыть',
      saveTemplate: 'Сохранить в качестве приглашения на данное собеседование',
      templateSaved: 'Сообщение было сохранено в качестве шаблона для этого интервью.',
      templateOptionsLabel: 'Select template',
    },

    modalEditStages: {
      title: 'Редактировать этапы приёма на работу',
      info: 'Вы можете редактировать, добавлять, удалять и менять порядок спецэтапов приёма на работу. Обратите внимание, что удаление этапа невозможно, если в системе имеются соискатели работы, привязанные к выбранному этапу.',
      addNewStage: 'Добавить новый спецэтап',
      removeDisabled: 'Этап, на котором присутствуют соискатели работы, нельзя удалить.',
      error: 'Такой этап уже существует.',
      done: 'Готово',
      save: 'Сохранить',
      close: 'Закрыть',
      confirm: 'Подтвердить',
      cancel: 'Отмена',
      delete: 'Удалить',
    },

    modalHidePositionsFromUser: {
      modalHeader: 'Скрытые вакансии',
      modalDescription: name => `Выберите, какие вакансии будут доступны пользователю ${name}.`,
      hiddenFrom: name => `Вакансии, скрытые от пользователя ${name}`,
      jobAdLabel: 'Объявление о вакансии',
      interviewLabel: 'Видеособеседование',
      noPositions: 'Нет вакансий',
      noResults: 'Результаты не найдены',
      close: 'Закрыть',
      hide: 'Скрыть',
      remove: 'Удалить',
      searchInfo: 'Просмотреть вакансии, подлежащие скрытию',
      searchPlaceholder: 'Поиск вакансий по названию или местонахождению',
      total: total => `Всего вакансий: ${total}`,
      labels: {
        title: 'Название',
        location: 'Расположение',
        time: 'Дата создания',
        actions: 'Действия',
      },
    },

    modalRemoveUserFromOrganisation: {
      modalHeader: 'Удаление пользователя из организации',
      modalDescription: name =>
        `Пользователь ${name} является внешним пользователем и будет удален только из этой организации. Несмотря на это удаление, он сохранит доступ к другим организациям в Recright.`,
      modalExplanation: name =>
        `Следовательно, у пользователя больше не будет доступа к вакансиям в этой организации. Вы унаследуете доступ к вакансиям, где ${name} был/была единственным рекрутером.`,
      adminInRecruitmentTeam: name =>
        `Вакансии, в которых пользователь ${name} входил в состав команды по подбору персонала:`,
      noResults: 'Результаты не найдены',
      noPositions: 'Нет вакансий',
      jobAdLabel: 'Объявление о вакансии',
      interviewLabel: 'Видеособеседование',
      total: total => `Всего вакансий: ${total}`,
      close: 'Закрыть',
      remove: 'Удалить из организации',
      removeUserConfirmMessage: 'Удалить пользователя',
      removeUserConfirmContent:
        'Вы уверены, что хотите удалить пользователя из этой организации?',
      labels: {
        title: 'Название',
        time: 'Дата создания',
        creator: 'Новый владелец вакансии',
      },
      otherAdmin: 'Другой администратор из команды по подбору персонала',
    },

    modalPersonStage: {
      new: 'Новый',
      hired: 'Нанят',
      proceed: 'На рассмотрении',
      videointerviewed: 'Видеоинтервью',
      personalinterview: 'Персональное интервью',
      withdrawn: 'Заявка снята',
      scheduledinterview: 'Собеседование в назначенное время',
      rejected: 'Отказ',
      change: 'Изменить статус кандидата(-ов)',
      info: 'Изменить статус выбранного(-ых) кандидата(-ов). Это действие не отображается кандидатам.',
      changedInfo: stage => `Сообщите кандидатам о переводе их кандидатур на этап "${stage}" с помощью сообщения по электронной почте или видео-сообщения!`,
      done: 'Переместить',
      cancel: 'Отмена',
      changed: 'Отлично!',
      close: 'Закрыть',
      reopenProcessConfirmPlural: 'Вы действительно хотите перевести данных соискателей с этапа "Заявка снята" и вернуть их в процесс подбора сотрудника на данную вакансию? После подтверждения данные соискатели смогут снова отвечать на вопросы тех собеседований по данной вакансии, на которые они ещё не внесли ответы полностью.',
      withdrawConfirmPlural: 'Вы действительно хотите вывести данных соискателей из процесса подбора сотрудника на данную вакансию? После вывода соискатели не смогут отвечать на вопросы собеседований по данной вакансии, на которые им были отправлены приглашения.',
      changeSingle: 'Перевести соискателя работы на другой этап',
      infoSingle: ' Перевести соискателя работы на другой этап. Это действие не отображается самому соискателю.',
      changedInfoSingle: stage => `Теперь, когда соискатель работы переведён на новый этап - "${stage}", вы можете рассказать ему/ей об этом. \n\n Отправьте соискателю электронное письмо или видео-сообщение.`,
    },

    modalInterviewAdd: {
      timedTitle: 'Собеседование, ограниченное по времени',
      timedDescription: 'Соискатели работы записывают свои ответы на вопросы собеседования в течение ограниченного временного интервала, заданного заранее. При составлении собеседования можно задать время отдельно на подготовку к ответу и отдельно на запись ответа.',
      title: 'Создать новое собеседование',
      description: 'Выберите тип создаваемого собеседования',
      friendlyTitle: 'Видео-собеседование стандартного образца',
      friendlyDescription: 'Соискатели работы могут записывать неограниченное количество попыток ответа на вопрос. При записи попытки ответа ограничения по времени нет.',
      cancel: 'Отмена',
      continue: 'Продолжить',
    },

    modalInterviewPublish: {
      modalTitle: 'Настройки публикации',
      publicTitle: 'Публичное интервью',
      publicDescription: 'Это интервью имеет общедоступную страницу с адресом, который вы можете использовать в своих объявлениях о работе и на странице Вашей компании. Любой, заинтересовавшийся вакансией, может изучить Ваши вопросы и принять решение об участии. Вы будете уведомлены о поступающих ответах.',
      publishButton: 'Создать публичную ссылку',
      unPublishButton: 'Удалить публичную ссылку',
      title: 'Встроенное интервью',
      description: 'Интервью может быть с легкостью добавлено на сайт Вашей компании. От кандидатов потребуется предоставить свой адрес электронной почты и записать ответ на видеоинтервью. По желанию можно запросить от кандидатов предоставить ссылку на профиль, напр-р в LinkedIn, в качестве дополнительной информации.',
      descriptionMultiple:
        'Органичная интеграция собеседования в формате видео в ваше объявление о вакансии или на домашнюю страницу компании. Кандидаты просто вводят свой адрес электронной почты, записывают ответы в формате видео, и у них есть возможность указать ссылку на свой профиль в LinkedIn для предоставления дополнительной информации.',
      embedNotification: 'Встроенное интервью может состоять только из одного вопроса.',
      embedButton: 'Создать код для вставки',
      unEmbedButton: 'Удалить вставку',
      close: 'Закрыть',
      oneError: 'Встроенное интервью может содержать только один вопрос. Удалите дополнительные вопросы, чтобы использовать код для вставки.',
      subscriptionNeeded: 'Для публикации интервью Вам потребуется активная подписка.',
    },

    modalIntroduce: {
      title: count => (count > 1 ? 'Представить кандидатов' : 'Представить соискателя'),
      descriptionFirst: 'С помощью функции представлений вы можете представлять выбранных соискателей работы своим коллегам или клиентам.',
      descriptionSecond: 'В поле, расположенном ниже, введите адреса электронной почты получателей представления. Выберите, какие данные о соискателе работы вы хотите показать получателям представления. Только выбранные вами данные будут отправлены получателям. Если вы выберете "Оценка" или "Области компетенции и профпригодность", получатели смогут давать оценки соискателям работы, а также просматривать средний балл соискателя.',
      descriptionThird: 'Отправляемые представления соискателей также можно защитить паролем, который будет необходимо ввести для того, чтобы просмотреть данные соискателей.',
      descriptionFourth: days =>
        `Срок действия ссылки на представление истекает через ${days} дней. Вы можете продлить срок действия ссылки в настройках представлений. Настройки находятся в меню «Редактировать», в подменю «Редактировать представления».`,
      titlePlaceholder: 'Название',
      contentPlaceholder: 'Содержимое сообщения',
      emailsPlaceholder: 'Адреса получателей',
      namePlaceholder: 'Имя',
      cancel: 'Отмена',
      sendIntroductions: 'Отправить представления',
      selectedCandidates: count => `${count} кандидат(ов) выбран(ы) для представления`,
      successMessage: (candidates, introducees) => `${candidates} кандидат(ов) представлен(ы) ${introducees} на рассмотрение`,
      infoMessage: (candidates, introducees, isInTeam) => `${candidates} соискателя (-ей) представлены ${introducees} сотрудникам. Из сотрудников ${isInTeam} чел. уже состоит в группе набора персонала.`,
      alreadyInTeam: inTeam => (inTeam > 1 ? 'уже в группе набора персонала.' : 'уже в группе набора персонала.'),
      name: 'Имя',
      email: 'Email',
      phone: 'Телефон',
      city: 'Город',
      coverLetter: 'Сопроводительное письмо',
      attachments: 'Резюме',
      links: 'Ссылки',
      competencies: 'Компетенции',
      rating: 'Рейтинг',
      videoResponses: 'Видео-ответы',
      comments: 'Комментарии',
      informationsHeader: 'Выбрать данные, которые будут включены в преставление',
      messageHeader: 'Заголовок представления',
      usePasscodeText: 'Защитить группу представления паролем',
      passcode: 'Пароль',
      copyToClipboard: 'Скопировать в буфер обмена',
      generatePasscode: 'Автоматически создать новый пароль',
      selectAll: 'Выделить все',
      resetSelection: 'Отменить выбор',
      copySuccess: 'Код-пароль скопирован!',
      close: 'Close',
      introduceLinkButton: 'Create link',
      introduceLink: 'Introduce link',
      introduce: 'Introduce',
      formError: 'Error',
      linkCreationError: 'Error creating introduction link',
      link: 'Link',
      continue: 'Продолжить',
    },

    modalInterviewInvite: {
      senderInfo: 'Приглашения отправляются с адреса электронной почты invitations@recright.com.',
      replyToEmail:
        'Ответное электронное письмо на приглашения на собеседование',
      replyToName: 'Имя отправителя для приглашений на собеседование',
      replyToInfo:
        'Вы можете редактировать эти поля на странице редактирования собеседования',
      notAnswerable: 'Вы не можете приглашать пользователей на закрытое интервью или интервью, у которого нет вопросов.',
      title: 'Пригласить кандидатов',
      description: 'Введите адреса электронной почты кандидатов.',
      description2: ' Вы будете уведомлены о поступающих ответах по электронной почте. Обратите внимание, что после отправки приглашений кандидатам у Вас не будет возможности добавить новые вопросы.',
      smsDescription: 'После рассылки приглашений по электронной почте соискателям работы можно также отправить СМС',
      addressesPlaceholder: 'Адреса электронной почты кандидатов',
      subjectPlaceholder: 'Тема',
      messagePlaceholder: 'Сообщение',
      namePlaceholder: 'Имя',
      submit: 'Отправить приглашение',
      cancel: 'Отмена',
      close: 'Закрыть',
      templateChangedInfo: 'Вы изменили сообщение с приглашением. Изменения будут отправлены текущей группе адресатов, но не будет сохранено в собеседовании',
      templateSaved: 'Сообщение сохранено как шаблон для собеседования.',
      inviteInfo: (newInvitees, stage) => `Приглашение будет отправлено ${newInvitees} соискателям из выбранных соискателей работы. Все выбранные соискатели будут переведены на этап «${stage}».`,
      invitesSent: (success, failed) => (failed > 0 ? `${success} приглашений отправлено и ${failed} уже были приглашены.` : `${success} приглашений отправлено.`),
      subscriptionNeeded: 'Для приглашения соискателей работы необходима действующая подписка.',
      templateOptionsLabel: 'Выбрать шаблон',
      saveTemplate: 'Сохранить в качестве приглашения на данное собеседование',
      rrTemplateOptionLabel: 'Шаблон RecRight по умолчанию',
      interviewTemplateOptionLabel: 'Приглашение на данное собеседование',
    },

    modalInterviewInviteSms: {
      title: 'Приглашения успешно отправлены',
      description: count => `Успешно отправлено приглашений: ${count}`,
      description2: 'Хотите ли вы также послать СМС приглашённым соискателям работы?',
    },

    modalSmsMessage: {
      description: count => `Сообщение будет отправлено${count} адресатам`,
      phonePlaceholder: 'Телефон',
      title: 'Отправить СМС',
      invitationTitle: 'Отправить приглашение по СМС',
      resendInvitationTitle: 'Повторно послать приглашение по СМС',
      missingInvitationDescription: count => `${count} получателей(я) не получили приглашения. Напишите им приглашение ниже.`,
      missingPhone: count => `У ${count} получателей(я) не значится действительного мобильного номера телефона.`,
      missingPhone2: 'Добавьте мобильные номера телефонов в поля ниже.',
      successMessage: count => `${count} СМС успешно отправлено.`,
      partialSuccessMessage: (successCount, failedCount) => `${successCount} СМС успешно отправлено. Не удалось отправить ${failedCount} СМС.`,
      failedMessage: 'Не удалось отправить ни одного СМС-сообщения получателям',
      recipientsNotFound: 'Произошла непредвиденная ошибка. Повторите попытку позже. При повторных сбоях пожалуйста свяжитесь со службой поддержки.',
    },

    modalInterviewStatus: {
      change: 'Изменить статус интервью',
      changed: 'Статус интервью изменен',
      changedInfo: 'Статус интервью изменен. Не забудьте сообщить кандидатам о своем решении!',
      info: 'Выберите новый статус интервью.',
      open: 'Открыто',
      closed: 'Закрыто',
      done: 'Готово',
      close: 'Закрыть',
      endTimeInPast: 'Для данного собеседования установлена дата окончания, находящаяся в прошлом. При открытии собеседования дата окончания удаляется. Новую дату окончания собеседования можно установить на ',
      endTimeInPastLink: 'странице редактирования',
      cancel: 'Отмена',
    },

    modalInterviewSelectForEdit: {
      title: 'Редактировать интервью',
      info: 'Выбрать собеседование для редактирования.',
      cancel: 'Отмена',
      done: 'Готово',
      error: {
        selectInterview: 'Пожалуйста, выберите интервью.',
      },
    },

    modalInterviewTeaser: {
      title: 'Сделайте правильный выбор с помощью видеоинтервью',
      content1: 'Видеоинтервью - следующий этап после получения откликов от кандидатов.',
      upgradeTitle: 'Апгрейд 295 Евро/месяц',
      upgradeDescription: 'Усовершенствуйте Ваш план подписки для получения доступа к 15 вакансиям с видеоинтервью в год. Ваш текущий план подписки будет заменен.',
      singleHireTitle: price => `Разовая подписка ${price} Руб/интервью`,
      singleHireDescription: 'Используйте видеоинтервью для одной вакансии в течение 60 дней. Вы можете пригласить несколько кандидатов.',
      tryTitle: 'Попробуйте бесплатно',
      tryDescription: 'Создайте видеоинтервью и запишите видеовопросы. Вам необходимо обновить план подписки или приобрести разовую подписку перед тем как Вы начнете приглашать кандидатов.',
      contactTitle: 'Связаться',
      contactDescription: 'Отправьте нам свой запрос, и мы свяжемся с Вами на следующий рабочий день!',
      cancel: 'Отмена',
      confirm: 'Продолжить',
      greetings: 'Сообщение отправлено.',
      confirmTitle: 'Подтвердить покупку',
      confirmDescription: 'Вы в одном клике от видеоинтервью. Просто подтвердите оплату и сервис будет готов к использованию!',
    },

    modalJobAdPreview: {
      title: 'Предварительный просмотр вакансии',
      description: 'Тут Вы можете посмотреть, как соискатель увидит Вашу вакансию.',
      description2: 'Обратите внимание, что язык, используемый в предварительном просмотре, не является языком, установленным в вакансии.',
      close: 'Закрыть',
      back: 'Назад',
    },

    modalJobAdStatus: {
      change: 'Изменить статус вакансии',
      changed: 'Статус вакансии изменен',
      changedInfo: 'Статус вакансии изменен. Не забудьте сообщить кандидатам о своем решении!',
      info: 'Выберите статус вакансии. При изменении статуса на "Закрыта" или "Отмена" не забудьте выбрать нанятых сотрудников и / или отправить остальным кандидатам письма с отказом.',
      open: 'Открыта',
      filled: 'Закрыта (выбран финалист)',
      cancelled: 'Отмена',
      done: 'Готово',
      close: 'Закрыть',
      draft: 'Скрыта(черновик)',
      closed: 'Скрыта',
      unpublished: 'Не опубликовано',
      hidden: 'Анонимная',
      openDescription: 'Вакансия действительна до',
      filledDescription: 'Закрыть объявление о вакансии, т.к. был найден подходящий кандидат.',
      cancelledDescription: 'Закрыть объявление о вакансии, т.к. поиск был отменен.',
      closedDescription: 'Объявление о вакансии закрыто. Оно недоступно для кандидатов и скрыто от них.',
      hiddenDescription: 'Скрыть позицию со страницы с вакансиями. Позиция будет доступна только по прямой ссылке:',
      unpublishedDescription: 'Объявление о вакансии не опубликовано. Оно недоступно для кандидатов и скрыто от них.',
      cancel: 'Отмена',
    },

    modalJobPositionTeam: {
      addAnother: 'Добавить пользователей через указание адресов электронной почты',
      team: 'Участники отбора',
      info: 'Вы можете добавлять коллег или других пользователей для просмотра и оценки кандидатов',
      newMembersMsg: 'Новые участники отбора, при отсутствии учетной записи в Recright, будут добавлены в организацию, которой принадлежит вакансия.* Если домен электронной почты пользователя не совпадает с доменом, привязанным к организации, пользователь получит минимальные права доступа. Эти права доступа пользователя могут быть изменены позднее администратором, имеющим доступ к панели управления пользователями.',
      asteriskSymbol: '*',
      currentTeam: 'Текущие участники отбора',
      done: 'Готово',
      remove: 'Удалить',
      submit: 'Добавить в команду по набору',
      cancel: 'Отмена',
      selfRemovedMessage: 'Вы удалились из команды по приёму на работу.',
      successMessage: count => `${count} сотрудника(-ов) добавлено в команду по набору.`,
      errors: {
        duplicate: 'Адрес электронной почты был введён ранее.',
        duplicateMultiple: 'Найден(ы) сотрудник(и) из списка имеющихся сотрудников по одному или нескольким введённым адресам электронной почты.',
        isEmail: 'Введён недействительный адрес электронной почты.',
        isEmailMultiple: 'Найдены недействительные адреса электронной почты.',
        isRequired: 'Поле обязательно для заполнения.',
      },
    },

    modalJobPositionCopy: {
      title: (context, position) => `Вы действительно хотите создать копию ${context === 'jobAd' ? 'вакансии' : 'видеоинтервью'} ${position.title}?`,
      admins: 'Копировать ли также состав команды, занимающихся подбором персонала?',
      done: 'Копировать',
      cancel: 'Отмена',
    },

    modalVideos: {
      title: 'Видеотека',
      yourVideos: 'Ваши видеоролики',
      companyVideos: 'Видеоролики компании',
      sort: {
        createdAt: 'Дата создания',
        title: 'Название',
      },
      add: 'Добавить',
      done: 'Добавить видео',
      cancel: 'Отмена',
    },

    modalUsersAdd: {
      title: 'Пригласить пользователей',
      languageDescription: 'Данные пользователи будут использовать язык:',
      permissionsDescription: 'У выбранных пользователей будут следующие права доступа:',
      emailsPlaceholder: 'Редактировать адрес электронной почты пользователя',
      seeAllPositions: 'Просмотреть все вакансии',
      createJobPositions: 'Создать вакансию',
      createInterviews: 'Создать собеседование',
      account: 'Редактировать данные компании',
      billing: 'Выставление счетов',
      reporting: 'Отчеты',
      editUsers: 'Редактировать пользователей',
      default: 'Права доступа компании по умолчанию',
      cancel: 'Отменить',
      submit: 'Пригласить пользователей',
    },

    modalCompanyDefaultPermissionsEdit: {
      title: 'Права доступа компании по умолчанию:',
      description: 'Все новые пользователи, регистрирующиеся в этой компании, автоматически получат права доступа по умолчанию.',
      seeAllPositions: 'Просмотреть все вакансии',
      createJobPositions: 'Создать вакансию',
      createInterviews: 'Создать собеседование',
      account: 'Редактировать данные компании',
      billing: 'Выставление счетов',
      reporting: 'Отчеты',
      editUsers: 'Редактировать пользователей',
      cancel: 'Отменить',
      submit: 'Сохранить',
    },

    modalOtherApplications: {
      title: 'Другие отклики на вакансии от кандидата',
      header: 'Вот список других вакансий, на которые откликнулся этот кандидат',
      close: 'Закрыть',
    },

    getPermissionsLabels: {
      permissions: {
        seeAllPositions: 'Просмотреть все вакансии',
        createJobPositions: 'Создать вакансию',
        createInterviews: 'Создать собеседование',
        account: 'Редактировать данные компании',
        billing: 'Выставление счетов',
        reporting: 'Отчеты',
        editUsers: 'Редактировать пользователей',
        default: 'Права доступа по умолчанию',
      },
    },

    // TODO: Translations missing!
    modalCronofy: {
      linkCalendar: {
        title: 'Link your calendar to Recright',
        description: 'Use our partner Cronofy to link your calendar to Recright',
        authorize: 'Authorize your calendar here',
        authorized: profileName => `You have successfully linked calendar ${profileName} to your Recright account`,
        revokeAuthorization: 'Unlink the calendar from Recright',
      },
      personalInterview: {
        title: 'Create the invitation for scheduled interview',
        description: 'If you’d like to meet the candidate in person, you may invite them to self-schedule a meeting. First, choose the interviewers for the meeting, then set your availability by choosing the dates, times as well as the length of the slots. Add in a message to personalize your invitation. \n\nThe candidate will receive an email to book the meeting. When the candidate chooses a time slot, the interviewers will get an email confirmation with the candidate’s details, and the meeting will appear on the calendar.',
        interviewersHeader: 'Select interviewers',
        noInterviewersSelected: 'Select at least one interviewer with linked calendar to continue',
        otherInterviewersHeader: 'Other interviewers',
        removeOtherInterviewers: 'Remove',
        deselectAll: 'Deselect all',
        selectAll: 'Select all',
        interviewerCalendarNotConnectedNote: 'The user\'s calendar is not linked to Recright. Scheduling information email will still be sent to the user\'s email.',
        singleInterviewer: 'Interviewer',
        allInterviewersCalendarNotConnected: 'None of the interviewers have their calendar connected to Recright',
        addMoreInterviewersToTeam: 'Click here to add more interviewers to the team',
        userCalendarNotConnected: 'You don\'t have your calendar connected to Recright',
        userConnectCalendar: 'Connect your calendar here',
        addNewInterviewer: 'Add new interviewer\'s email address',
        timeSlot: {
          description: 'Choose the timeframe and interview length for the interview.\nAfter that you see what slots are available for candidate to choose from.',
          startDate: 'Timeframe start date',
          endDate: 'Timeframe end date',
          endDatePlaceholder: 'End date',
          startDatePlaceholder: 'Start date',
          endDateWarning: 'Select the time frame end date for the scheduled meetings',
          startTime: 'Start time for the day',
          endTime: 'End time for the day',
          timezone: 'Time zone',
          timezoneHelp: 'Please note that changing the timezone also adjusts date and time accordingly.',
        },
        useAllTimeSlots: 'Let candidate choose from all available time slots in the chosen timeframe',
        noTimeSlotsSelected: 'Select at least one timeslot from the Availability below\nor let the candidate choose from all available time slots',
        slotPickerDescription: 'See what slots are available for candidate to choose from.',
        showAvailability: 'Show availability',
        refreshAvailability: 'Refresh availability',
        slotLength: 'Slot length',
        availabilityError: 'Unable to show availability. Please try again later and if the problem persists please contact our support.',
        recipients: count => `Message will be sent to ${count} candidates`,
        confirmRescheduleMessage: 'Перенести встречу',
        confirmRescheduleContent: 'У некоторых получателей приглашения уже запланирована встреча. Вы действительно хотите разослать новые приглашения? Таким образом ранее запланированная встреча будет замещена на новую.',
      },
      personalInterviewMessage: {
        title: 'Create message for calendar invitation',
        successTitle: 'Great',
        successDescription: candidateLength => `You invited ${candidateLength} people to personal interview. They have also been moved to stage 'Personal Interview'`,
        message: {
          emailMessage: 'Email message',
          title: title => `Let’s have a meeting regarding ${title}`,
          content: title => `Hey! We were impressed with your application for ${title} position and would like to invite you for a meeting and tell you a little more about the position and get to know you better.\n\nPlease let me know which of the following times best for you by clicking this scheduling link.\n\nLooking forward to meeting you!`,
          event: {
            header: 'Calendar event information',
            description: 'Insert here information that is included in the calendar event',
            titlePlaceholder: 'Event title',
            locationPlaceholder: 'Event location',
          },
        },
        close: 'Close',
        saveDefaultLocation: 'Save location as default location',
        savedDefaultLocation: 'Saved as default location',
        invitationError: 'We were unable to send calendar invitation. Please try again later and if the problem persists please contact our support.',
      },
    },

    // TODO: Translations missing!
    modalVideoEdit: {
      save: 'Сохранить',
      cancel: 'Отмена',
      addTag: 'Добавить тэг',
      title: 'Редактировать видео',
      success: 'Изменения в видео успешно сохранены!',
      error:
        'Не удалось сохранить изменения в видео. Повторите попытку позже. Если проблема не исчезнет, ​​обратитесь в нашу службу поддержки.',
    },

    noResults: {
      description: 'Кажется, Ваш список пуст. Если Вы применили фильтры, попробуйте сократить их число.',
    },

    notifications: {
      notifications: 'Уведомления',
    },

    notificationsSubscribeButton: {
      subscribe: 'Подписаться',
      subscribed: 'Подписка оформлена',
      unsubscribe: 'Отписаться',
    },

    onboardTutorial: {
      ui: {
        back: 'Назад',
        close: 'Закрыть',
        last: 'Готово',
        next: 'Далее',
        skip: 'Пропустить',
      },
      dashboard: [
        {
          title: 'Welcome to Recright!',
          text: 'First thing first. Let\'s connect your calendar, so you can schedule meetings with candidates! <a href="/admin/account">Connect your calendar here!</a>',
          selector: '.joyride--welcome-calendar',
          position: 'top',
          style: {
            beacon: {
              offsetY: -625,
            },
          },
        },
        {
          title: 'Добро пожаловать в Recright!',
          text: 'Для получения подсказок, нажмите на круглый зеленый значок «i». Подсказки можно открыть в любое время, нажав на Ваше имя и выбрав пункт "Показать подсказки".',
          selector: '.joyride--welcome',
          position: 'top',
          style: {
            beacon: {
              offsetY: -625,
            },
          },
        },
        {
          title: 'Создать новую вакансию',
          text: 'Здесь Вы сможете создать и опубликовать новую вакансию и начать получение откликов от кандидатов.',
          selector: '.joyride--add-job-ad',
          position: 'bottom-left',
        },
        {
          title: 'Создать новое видеоинтервью',
          text: 'Здесь Вы сможете создать новое видеоинтервью и пригласить кандидатов.',
          selector: '.joyride--add-videointerview',
          position: 'bottom-left',
        },
        {
          title: 'Настройки',
          text: 'Здесь Вы можете изменить настройки учетной записи, получить доступ к своей видеотеке, выбрать вид корпоративной карьерной страницы и текст URL-адреса, а также предпочитаемый язык интерфейса. Вы также можете перейти к этому руководству путем нажатия "Показать подсказки".',
          selector: '.joyride--profile-settings',
          position: 'bottom-left',
        },
      ],
      accountDetails: [
        {
          title: 'Connect your calendar here!',
          text: 'Come on! Do it! Do it now! What are you waiting for?! Do it now!',
          selector: '.joyride--connect-calendar',
          position: 'top',
        },
      ],
      jobAdEdit: [
        {
          title: 'Добавить баннер и логотип',
          text: 'Вы можете добавить баннер в объявление о вакансии. Оптимальный размер изображения 1440 x 320 пикселей. Также, не забудьте добавить логотип Вашей компании.',
          selector: '.joyride--job-ad-images',
          position: 'top',
        },
        {
          title: 'Название, местоположение и крайний срок подачи заявок',
          text: 'Введите название вакансии, ее местоположение, установите дату публикации и крайний срок подачи заявок. Если сроки действия не указаны, то видеоинтервью будет доступно на неопределенный срок.',
          selector: '.joyride--job-ad-title',
          position: 'top',
        },
        {
          title: 'Описание вакансии',
          text: 'Введите описание вакансии здесь. Не забудьте упомянуть, какого сотрудника Вы ищете, каковы Ваши требования и условия.',
          selector: '.joyride--job-ad-description',
          position: 'top',
        },
        {
          title: 'Корпоративное видео',
          text: 'Вы можете включить в объявление о вакансии свое корпоративное видео. Такое видео позволит представить корпоративную культуру и продвинуть HR-бренд работодателя.',
          selector: '.joyride--job-ad-employer-video',
          position: 'top',
        },
        {
          title: 'Настройка формы отклика',
          text: 'Выберите, какую информацию Вы бы хотели получить от кандидатов. Поля могут быть как обязательными, так и необязательными для заполнения.',
          selector: '.joyride--job-ad-application-setup',
          position: 'top',
        },
        {
          title: 'Видеовопрос',
          text: 'Вы можете задать первый видеовопрос своим кандидатам уже на этапе подачи заявок. Видеоответы помогут Вам лучше узнать кандидатов и внесут разнообразие в процесс отбора.',
          selector: '.joyride--job-ad-video-questions',
          position: 'right',
        },
      ],
      interviewEdit: [
        {
          title: 'Добавить баннер и логотип',
          text: 'Вы можете добавить баннер в интервью. Оптимальный размер изображения 1440 x 320 пикселей. Также, не забудьте добавить логотип Вашей компании.',
          selector: '.joyride--interview-images',
          position: 'top',
        },
        {
          title: 'Название интервью, крайний срок подачи заявок',
          text: 'Введите название видеоинтервью и установите сроки ответа. Если Вы не определите срок записи, видеоинтервью останется доступным для записи на неопределенный срок.',
          selector: '.joyride--interview-title',
          position: 'top',
        },
        {
          title: 'Настройка анкеты',
          text: 'Выберите, какую информацию Вы бы хотели получить от своих кандидатов. Поля могут быть как обязательными, так и необязательными для заполнения.',
          selector: '.joyride--interview-form-setup',
          position: 'top',
        },
        {
          title: 'Вопросы интервью',
          text: 'Запишите или загрузите Ваши видеовопросы. После загрузки Вы можете сохранить видеовопросы в библиотеку и использовать их впоследствии. Вы также можете использовать текстовые вопросы, если у Вас нет возможности использовать видеовопросы. Кандидаты всегда отвечают с видео.',
          selector: '.joyride--interview-video-questions',
          position: 'top',
        },
      ],
      createdJobAd: [
        {
          title: 'Действия с вакансией',
          text: 'Здесь можно редактировать вакансию, изменять её состояние и пригласить коллег, чтобы они дали оценку соискателям работы.',
          selector: '.joyride--created-actions-left',
          position: 'top',
        },
        {
          title: 'Продвижение вакансии',
          text: 'Вы можете продвигать вакансию, размещая объявления о ней в своих профилях соцсетей.',
          selector: '.joyride--created-actions-right',
          position: 'top',
        },
      ],
      createdInterview: [
        {
          title: 'Действия с видеоинтервью',
          text: 'Здесь можно редактировать видео-собеседование, изменять его состояние и пригласить коллег, чтобы они дали оценку соискателям работы.',
          selector: '.joyride--created-actions-left',
          position: 'top',
        },
        {
          title: 'Настройки приглашений и публикаций в соцсетях',
          text: 'Предложите соискателям работы опубликовать видео-собеседование с ними – отправьте им соответствующее приглашение. После этого вы можете продвигать видео-собеседование, публикуя его в своих профилях соцсетей.',
          selector: '.joyride--created-actions-right',
          position: 'top',
        },
      ],
      ApplicationView: [
        {
          title: 'Комментарии и категории',
          text: 'Вы можете комментировать профили кандидатов, добавлять тэги и присваивать рейтинг с помощью звезд. Не забудьте указать статус кандидата, чтобы коллеги знали о Вашем решении. Данная информация будет скрыта от кандидатов.',
          selector: '.joyride--comments',
          position: 'top',
        },
      ],
    },

    organisationSubMenu: {
      index: 'Управление учетной записью',
      branding: 'Фирменное оформление',
      stages: 'Этапы',
      emailTemplates: 'Шаблоны сообщений для электронной почты',
      competencies: 'Компетенции',
    },

    passcode: {
      passcode: 'Пароль',
      showPasscode: 'Показать код-пароль',
      hidePasscode: 'Скрыть код-пароль',
    },

    passwordIndicator: {
      errors: [
        'Пароль должен содержать не менее 12 символов.',
        'Пароль должен содержать не более 128 символов.',
        'Пароль не должен содержать комбинации из трех и более последовательно повторяющихся символов.',
        'Пароль должен содержать по крайней мере одну строчную букву: a-z',
        'Пароль должен содержать по крайней мере одну заглавную букву: A-Z',
        'Пароль должен содержать по крайней мере одну цифру: 0-9',
        'Пароль должен содержать по крайней мере один специальный символ: (например: !, #, &)',
      ],
      strengthLabel: 'Сложность пароля: ',
      strengthValue: {
        insufficient: 'Ненадежный',
        weak: 'Слабый',
        medium: 'Средний',
        strong: 'Сильный',
      },
      learnMore: 'Узнайте, как создать надежный пароль',
    },

    personDetails: {
      namePlaceholder: 'Соискатель',
      links: 'Ссылки',
      attachments: 'Вложения',
      coverLetter: 'Сопроводительное письмо',
      referrer: 'Реферер',
      referrerInfo: 'Веб-сайт, с которого пришел кандидат.',
      lastSeen: time => `Последнее время посещения ${time}.`,
      headerAdditionalInformation: 'Дополнительные данные',
      state: {
        invited: 'Отправлено приглашение',
        visited: 'Было посещение',
        incomplete: 'Заполнение не зaкончено',
        completed: 'Заполнение зaкончено',
      },
      notVisited: 'Не проходил интервью.',
      otherPersons: count => `Также найдены отклики на ${count} других вакансиях`,
      name: 'Имя',
      email: 'Email',
      phone: 'Телефон',
      city: 'Город',
    },

    personEdit: {
      header: 'Редактировать данные соискателя',
      description: context => `Все общие данные по соискателям работы, отображаемые самим соискателям, можно редактировать в форме данных ${context === 'application' ? 'заявления на работу' : 'собеседования'} .`,
      name: 'Имя и фамилия соискателя работы',
      email: 'Введите адрес электронной почты кандидата',
      city: 'Текущий город проживания соискателя работы',
      phone: 'Телефон соискателя работы',
      link: 'Добавить ссылку, например, на Ваш профиль в LinkedIn.',
      links: 'Здесь Вы можете добавить ссылки, например, на Вашу страницу в LinkedIn',
      coverLetter: 'Сопроводительное письмо',
      attachments: 'Вложения',
      save: 'Сохранить',
      cancel: 'Отмена',
      editDetails: 'Редактировать данные',
      editSuccess: 'Данные соискателя сохранены!',
    },

    personRow: {
      noStage: 'без статуса',
      lastSeen: time => `Последнее время посещения ${time}.`,
      notVisited: 'Посещений не было.',
      selectPerson: 'Выбрать',
      deselectPerson: 'Убрать выделение',
      openPersonPage: 'Открыть',
      icons: {
        messages: messagesSent => `${messagesSent} сообщений отправлено`,
        message: messagesSent => `${messagesSent} сообщение отправлено`,
        noMessages: 'Нет отправленных сообщений',
        introduction: introductions => `${introductions} описание`,
        introductions: introductions => `${introductions} описаний`,
        noIntroductions: 'Нет описаний',
        comment: comments => `${comments} комментарий`,
        comments: comments => `${comments} комментариев`,
        noComments: 'Нет комментариев',
        appliedWithLinkedIn: 'Использовал LinkedIn',
      },
      state: {
        invited: 'Отправлено приглашение',
        visited: 'Было посещение',
        incomplete: 'Заполнение не зaкончено',
        completed: 'Заполнение зaкончено',
      },
    },

    pipeline: {
      editInterview: 'Редактировать интервью',
      titleLabel: 'Название',
      endTimeLabel: 'Действительно до',
      statusLabel: 'Статус',
      locationLabel: 'Местоположение',
      editStages: 'Редактировать этапы',
      interviewSchedulingDescription: 'This stage contains candidates that have peen invited to a personal meeting.',
      pipelineTooltip: ' Отслеживайте кандидатов на протяжении всего процесса привлечения на работу. Перемещайте кандидатов с одного этапа процесса найма на другой. Заявления на работу можно фильтровать по этапам соискателей или другим критериям поиска.',
    },

    positionListing: {
      type: 'Тип',
      title: 'Заголовок',
      owner: 'Владелец',
      count: 'Количество',
      invited: 'Приглашен',
      visited: 'Посетил',
      answered: 'Ответил',
      hired: 'Нанят',
      leadTime: 'Время разработки кандидатуры',
      leadTimeValue: v => `${v} дней`,
      created: 'Дата создания (GMT)',
      start: 'Дата публикации (GMT)',
      end: 'Дата окончания (GMT)',
      jobAdLabel: 'Объявление о вакансии',
      interviewLabel: 'Видеособеседование',
      timedLabel: 'Собеседование, ограниченное по времени',
      embedLabel: 'Встроенное интервью',
      publicLabel: 'Публичное интервью',
      timezone: 'Timezone',
      feedback: 'Сводные сведения по отзывам',
    },

    qrCodeDownload: {
      download: 'Скачать QR-код',
    },

    recentPositionsContainer: {
      createNew: 'Создать новую',
      showAll: 'Просмотреть все',
    },

    recentJobAds: {
      openJobPositions: 'Вакансии для публикации',
      showAllJobPositions: 'Показать все вакансии',
      createNewJobPosition: 'Создать новую вакансию',
      subscriptionNeeded: 'Для публикации вакансии Вам потребуется активная подписка.',
      confirmSingleHire: 'Один из приобретенных Вами инструментов разовой подписки используется для этой позиции.',
      newApplications: 'Непросмотренные',
      responses: 'Отклики',
    },

    recentInterviews: {
      openVideoInterviews: 'Видеоинтервью',
      showAllVideoInterviews: 'Показать все видеоинтервью',
      createNewVideoInterview: 'Создать новое видеоинтервью',
      invites: 'Приглашения',
      responses: 'Ответы',
      timedTitle: 'Собеседование, ограниченное по времени',
    },

    registrationForm: {
      email: 'Email',
      submit: 'Авторизоваться',
      password: 'Пароль',
      confirmPassword: 'Подтвердите пароль',
      agreeTos: 'Мной прочитано и одобрено ',
      agreeTosLinkText: 'Условия и положения для пользователей Recright.',
      privacyPolicy: 'Я ознакомился.',
      privacyPolicyLinkText: 'Политика конфиденциальности.',
      licenseAgreement: 'От имени представляемой мной организации я принимаю ',
      licenseAgreementLinkText: 'Общие условия оказания услуг Recright.',
      newsletter: 'Подписаться на ежемесячную рассылку.',
      name: 'Имя',
      namePlaceholder: 'Имя Фамилия',
      organization: 'Организация',
      companyDomain: domain => `Позволить добавление к данной компании пользователей, использующих электронную почту домена ${domain}.`,
      error: {
        password: {
          isRequired: 'Необходимо ввести пароль.',
          isValidPassword: 'В пароле должна быть как минимум одна заглавная буква, одна прописная буква и одна цифра. Длина пароля – минимум 12 символов.',
          passwordsMatch: 'Пароли не совпадают.',
        },
      },
    },

    requestCustomPlan: {
      info: 'Работаете с большим количеством вакансий?',
      cta: 'Запросить цену для индивидуального плана',
      successMessage: 'Запрос отправлен.',
    },

    subscriptionNeededAlert: {
      contactPersonWithBillingPermission: 'Обратитесь к лицу, ответственному за выставление счетов в вашей организации.',
    },

    search: {
      placeholder: 'Поиск',
    },

    searchFilter: {
      filter: 'Фильтр',
      headings: {
        stage: 'Этап',
        location: 'Местоположение',
        status: 'Статус',
        state: 'Статус',
        tags: 'Теги',
        rating: 'Рейтинг',
      },
      state: {
        invited: 'Прошел видеоинтервью',
        visited: 'В процессе прохождения интервью',
        incomplete: 'Отправлено приглашение',
        completed: 'Посетил страницу видеоинтервью',
      },
      status: {
        open: 'Открыто',
        filled: 'Закрыто (выбран финалист)',
        cancelled: 'Отмена',
        closed: 'Скрыто',
        draft: 'Скрыто (черновик)',
        unpublished: 'Не опубликовано',
        hidden: 'Анонимное',
        new: 'Новый',
        all: 'Все',
        hired: 'Нанят',
        proceed: 'В процессе',
        videointerviewed: 'Видеоинтервью',
        personalinterview: 'Личное интервью',
        withdrawn: 'Заявка снята',
        scheduledinterview: 'Собеседование в назначенное время',
        rejected: 'Отказ',
        finished: 'Окончено',
        coming: 'Предстоящее',
        active: 'Активно',
      },
    },

    selectListings: {
      title: 'Места публикации объявлений',
      description: 'Выбрать место публикации объявления о вакансии.',
    },

    session: {
      account: 'Управление учетной записью',
      language: 'Язык',
      logout: 'Выйти',
      whatsNew: 'What\'s New',
      trainingMaterial: 'Курсы обучения Recright',
      expired: 'Пожалуйста, авторизуйтесь заново.',
      showTutorial: 'Показать подсказки',
      helpCenter: 'Recright Help Center',
      organization: 'Организация',
    },

    showFeedbackPulse: {
      showPulse: 'Показать отзывы',
      positive: avg => `Положительных отзывов: ${avg}%`,
      feedbackStatistics: 'Сводные сведения по отзывам',
      noFeedback: 'Отзывов пока нет',
      responses: responses => `Ответов: ${responses}`,
    },

    singleHireUseNotification: {
      notificationHeader: count => `У Вас осталось ${count} возможностей единичного найма.`,
      notificationBody: 'При приглашении кандидатов или публикации интервью будет использована одна разовая подписка.',
    },

    singleHires: {
      currentCount: count => `Доступно ${count} возможностей разовой подписки.`,
      purchase: 'Приобрести разовую подписку',
      label: 'Разовая подписка',
      confirmMessage: amount => `Подтвердите покупку разовой подписки. ${amount} рублей будет списано с Вашей кредитной карты.`,
    },

    smartrecruitersPublish: {
      title: 'Интеграция со Smartrecruiters',
      description: 'Теперь вы можете удалять и добавлять собеседования в список видео-собеседований в Smartrecruiters.',
      notification: 'Примите во внимание, что на обновление списка собеседований Smartrecruiters может потребоваться до 24 часов.',
      addButton: 'Добавить в Smartrecruiters',
      removeButton: 'Удалить из Smartrecruiters',
      confirmRemove: 'Действительно удалить собеседование из Smartrecruiters?',
      addConflict: 'Данное собеседование уже добавлено в список видео-собеседований',
      removeConflict: ' Данное собеседование уже удалено из списка видео-собеседований',
    },

    subscriptionExpired: {
      message: 'Срок Вашей подписки истек.',
    },

    subscriptionPlan: {
      plan: 'План',
      noActivePlan: 'У вас нет активной подписки.',
      changePlan: 'Изменить план подписки',
      createSubscription: 'Создать новую подписку',
      save: 'Сохранить',
      cancel: 'Отмена',
      errorFromProcessor: error => `Платёжная система выдала ошибку: ${error}`,
    },

    stars: {
      yourRating: rating => `Ваш рейтинг: ${rating}`,
      totalVotes: count => `Всего ${count} голосов`,
      yourRatingReset: 'Отменить Ваш голос',
    },

    statisticsFilters: {
      timeframe: 'Timeframe',
      owner: 'Owner',
    },

    csStatisticsFilters: {
      timeframe: 'Timeframe',
      autoSuggestCompany: 'Company name',
      companyId: 'Company ID',
      companyDomain: 'Company domain',
      note: 'Note: ',
      noteText:
        'Company name is case sensitive. Company name suggestions are only shown for companies with > 1 jobads or jobopenings.',
    },

    statisticsSummary: {
      jobCountLabel: 'Open job count',
      interviewsLabel: 'Interviews',
      applicationsLabel: 'Applications',
      answersLabel: 'Interview answers',
      activeUsersLabel: 'Active users',
      avgLeadTimeLabel: 'Average lead time',
      avgLeadTimeValue: value => `${value} days`,
    },

    status: {
      opening: {
        open: 'Открыта',
        filled: 'Закрыта (выбран финалист)',
        cancelled: 'Отмена',
        closed: 'Скрыта',
        draft: 'Скрыта (черновик)',
        hidden: 'Анонимная',
        unpublished: 'Не опубликовано',
      },
      person: {
        new: 'Новый',
        hired: 'Нанят',
        proceed: 'В процессе',
        videointerviewed: 'Видеоинтервью',
        personalinterview: 'Личное интервью',
        withdrawn: 'Заявка снята',
        scheduledinterview: 'Собеседование в назначенное время',
        rejected: 'Отказ',
      },
    },

    transactionList: {
      noTransactions: 'Транзакции отсутствуют',
      createdAt: 'Дата',
      type: 'Тип',
      status: 'Статус',
      amount: 'Количество',
      receipt: 'Чек',
      statuses: {
        authorization_expired: 'Время авторизации истекло',
        authorized: 'Авторизация пройдена',
        authorizing: 'Авторизация в процессе',
        settlement_pending: 'Ожидание разрешения',
        settlement_confirmed: 'Разрешение получено',
        settlement_declined: 'Отказано в разрешении',
        failed: 'Не удалось',
        gateway_rejected: 'Отказано в доступе',
        processor_declined: 'Отказ процессора',
        settled: 'Разрешено',
        settling: 'Получение разрешения',
        submitted_for_settlement: 'Отправлено на согласование',
        voided: 'Аннулировано',
      },
      types: {
        sale: 'Sale',
        credit: 'Кредит',
      },
      download: 'Скачать',
      downloadReceipt: 'Скачать квитанцию',
      notSettled: 'Ожидание разрешения',
    },

    trialBanner: {
      notification: days => `У Вас осталось ${days} дн. пробной подписки. Чтобы продолжить пользование услугами Recright после окончания пробного периода, приобретите подходящий Вам вариант подписки.`,
      trialEnded: 'Пробный период действия сервиса истёк. Чтобы продолжить пользование сервисом, пожалуйста, приобретите подписку или одну вербовку, разовую услугу для одного приёма на работу.',
      orderHere: 'Оформить подписку',
    },

    updateCreditCard: {
      save: 'Сохранить',
      cancel: 'Отмена',
    },

    favorite: {
      popupHeader: 'Выберите видеотеку',
      yourVideos: 'Ваши видеоролики',
      companyVideos: 'Видеоролики компании',
    },

    FavoritesInfo: {
      Favorites: videoLibrary => `Добавляйте свои видео в Избранное, нажимая на иконку с сердечком. Убрать видеоролики из избранного можно через <a href="${videoLibrary}">Видеотеку</a>.`,
    },

    brandingPreview: {
      preview: 'Предпросмотр',
      header: 'Пример заголовка',
      body: lorem => `Это образец шрифта текста. ${lorem}`,
      linkText: 'Это образец ссылки.',
      primaryButtonText: 'Главная кнопка',
      secondaryButtonText: 'Вспомогательная кнопка',
      backButtonText: 'Кнопка возврата',
    },

    usersList: {
      generalInformation: 'Общие сведения',
      latestVisit: date => `Последнее посещение ${date}`,
      neverLogger: 'Никогда не заходил',
      externalUser: 'Внешний пользователь',
      inviteExpired: 'Срок действия приглашения истек',
      permissions: {
        permissions: 'Права доступа',
        seeAllPositions: 'Просмотреть все вакансии',
        createJobPositions: 'Создать вакансию',
        createInterviews: 'Создать собеседование',
        account: 'Редактировать данные компании',
        billing: 'Выставление счетов',
        reporting: 'Отчеты',
        editUsers: 'Редактировать пользователей',
        default: 'Права доступа по умолчанию',
      },
      actions: {
        actions: 'Действия',
        activate: 'Активировать',
        deactivate: 'Деактивировать',
        removeFromOrganisation: 'Удалить из организации',
        hiddenPositions: 'Скрытые вакансии',
      },
      noUsers: 'Пользователи не найдены. Если вы использовали фильтры поиска, попробуйте отключить некоторые из них.',
    },

    usersListFilters: {
      sort: {
        name: 'Имя',
        email: 'Адрес электронной почты',
        lastAdminAccess: 'Последняя сессия администратора',
      },
      find: 'Поиск',
      clearSelections: 'Очистить выбор',
      usersCount: count => `Всего пользователей: ${count}`,
    },

    usersListActions: {
      editMultipleUsersPermissions: 'Редактировать права доступа нескольких пользователей',
      deactivateSelectedUsers: 'Деактивировать выбранных пользователей',
      activateSelectedUsers: 'Активировать выбранных пользователей',
      addNewUsers: 'Пригласить пользователей',
      save: 'Сохранить',
      cancel: 'Отменить',
      editUsersPermissions: 'Редактировать права доступа пользователей',
    },

    linkedInInformation: {
      title: 'Данные профиля LinkedIn:',
      since: 'Дата начала',
      summary: 'Общие сведения:',
      fullLinkedInProfile: 'Полный профиль LinkedIn',
    },

    colorPicker: {
      reset: 'Reset',
    },

    emailDeliveryStatus: {
      Undetermined: {
        Undetermined: 'Ошибка при отправке сообщения по электронной почте. Проверьте, получил ли адресат отправленное вами сообщение.',
      },
      Permanent: {
        General: 'Не удалось доставить сообщение. Почтовый домен получателя не принял отправленное вами сообщение.',
        NoEmail: 'Указанный адрес электронной почты не существует.',
        Suppressed: 'Сообщение по электронной почте так и не доставлено после нескольких попыток его доставки получателю.',
      },
      Transient: {
        General: 'Ошибка при отправке сообщения по электронной почте. Проверьте, получил ли адресат отправленное вами сообщение.',
        MailboxFull: 'Ящик входящих писем получателя переполнен.',
        MessageTooLarge: 'Размер сообщения превышает допустимый максимум.',
        ContentRejected: 'Контент сообщения не принят доменом получателя.',
        AttachmentRejected: 'Приложение к сообщению не принято доменом получателя.',
      },
    },

    videoBackgroundUpload: {
      header: 'Фоновое изображение видео организации',
      description:
        'Изображение, которое пользователи вашей организации могут использовать в качестве фонового для записываемых ими видеороликов.',
      add: 'Добавить фоновое изображение видео',
      info: 'Рекомендуемый размер изображения — 720x480 пикселей.',
    },
  },

  page: {
    account: {
      title: 'Профиль организации',
      details: 'Параметры профиля организации',
      name: 'Название организации',
      save: 'Сохранить',
      saved: 'Информация учетной записи сохранена.',
      signature: 'Подпись',
      permissions: 'Права доступа',
      calendar: {
        label: 'Calendar',
        notAuthorized: 'Authorize your calendar here',
        authorized: 'Edit your calendar authorization',
        revokeError: 'We were unable to unlink your calendar. Please try again later and if the problem persists please contact our support.',
        revokeSuccess: 'Successfully unlinked your calendar',
      },
      password: 'Пароль',
      statistics: 'Statistics',
      organization: 'Организация',
    },

    actionBar: {
      selection: 'выбрано',
    },

    organisationProfile: {
      title: 'Управление учетной записью',
      details: 'Детали учетной записи',
      brandingHeader: 'Фирменная символика организации',
      name: 'Название учетной записи',
      owner: 'Владелец учетной записи',
      customReplyToSubtitle:
        'Здесь вы можете отредактировать имя отправителя и адрес для ответа на приглашения на собеседование. Если оставить поле пустым, будут подставляться имя и электронная почта пользователя, отправляющего приглашения',
      customReplyToEmail:
        'Ответное электронное письмо на приглашения на собеседование',
      customReplyToName: 'Имя отправителя для приглашений на собеседование',
      senderInfoDisabled:
        'Обновление информации об отправителе приглашения на собеседование отключено, поскольку в вашей организации отключены собеседования по видеосвязи',
      slug: 'URL корпоративной страницы',
      slugUnavailable: 'Этот URL уже занят.',
      slogan: 'Слоган корпоративной страницы',
      language: 'Язык корпоративной страницы',
      languagePlaceholder: 'Выбрать',
      rss: 'Карьерный RSS feed',
      type: 'Тип учетной записи',
      types: {
        free: {
          title: 'Бесплатная учетная запись',
          description: 'Преимущества бесплатной учетной записи\n1 пользователь\n1 открытие вакансии в удобное время',
        },
        basic: {
          title: 'Базовая',
          description: 'Преимущества базовой учетной записи \nНеограниченное число открытых позиций\nВидеоинтервью',
        },
        team: {
          title: 'Групповая',
          description: 'Преимущества групповой учетной записи \nНеограниченное число открытых позиций\nВидеоинтервью\nПрезентации кандидатов',
        },
      },
      save: 'Сохранить',
      reset: 'Reset',
      companyAdminUsers: 'Company admin users',
      saved: 'Информация об организации сохранена.',
      cancel: 'Отмена',
      confirmLeave: 'У вас есть несохраненные изменения. Вы уверены, что хотите выйти?',
      error: {
        required: 'Элементы, отмеченные звездочкой (*) обязательны для заполнения.',
      },
      emailBrandingHeader: 'Фирменный стиль электронной почты',
      emailBrandingDescription:
        'Настройте цветовое решение электронных писем, отправляемых кандидатам.',
    },

    organisationCompetencies: {
      title: 'Компетенции организации',
      description: 'Вы можете добавлять, редактировать и удалять компетенции. Эти компетенции будут использоваться по умолчанию на новых вакансиях, созданных в этой компании, и в профилях кандидатов, которые откликнулись на эти вакансии, в разделе «Компетенции».',
    },

    organisationStages: {
      title: 'Этапы приёма на работу в организации',
      description: 'Здесь можно редактировать, добавлять, удалять и менять порядок этапов приёма на работу в выбранной организации. Этапы, определённые здесь, станут этапами по умолчанию для новых вакансий, открываемых в данной организации.',
    },

    organisationEmailTemplates: {
      preview:
        'Предпросмотр сообщения (в предпросмотре нет всех элементов форматирования, присутствующих в окончательной версии сообщения)',
      preview2:
        'Цвета шаблонов электронных писем выбираются на странице настроек фирменного стиля организации.',
      timedInterviewPreviewInfo:
        'Сообщение о собеседовании, ограниченном по времени, не содержит информации о связи со службой поддержки.',
      templateTypes: {
        interviewInvite: 'Приглашение на видеоинтервью',
        timedInterviewInvite: 'Приглашение на видеоинтервью, ограниченное по времени',
        interviewCompleted:
          'Собеседование завершено / благодарственное сообщение для кандидатов',
        applicationCompleted:
          'Заявка на объявление о работе заполнена / благодарственное сообщение для соискателя',
      },
      subHeaders: {
        jobAdLabel: 'Объявление о вакансии',
        interviewLabel: 'Видеособеседование',
      },
      deleteTemplate: 'Удалить шаблон',
      confirmation: templateName =>
        `Вы действительно хотите удалить шаблон "${templateName}" из шаблонов электронной почты вашей организации?`,
      deleteSuccess: 'TШаблон удален из шаблонов эл. почты организации.',
      emailTemplateInfo: 'Пока что можно сохранить лишь один шаблон на одном языке.',
      templateError: 'Template with same name or language already exists',
    },

    application: {
      interviewClosed: 'Собеседование закрыто',
      back: 'Вернуться к списку откликов',
      delete: 'Удалить отклик',
      deleted: 'Отклик удален',
      resendInvitation: 'Отправить приглашение кандидату повторно',
      changeStage: 'Перевести на другой этап',
      commentsAndClassifications: 'Комментарии и категории',
      openingTitle: title => `Видеоинтервью - ${title}`,
      yourRatingText: 'Ваш рейтинг:',
      competencesAndCompatibility: 'Компетенции',
      duplicateCompetency: 'Компетенция уже существует',
      competencyNotFound: 'Компетенция не найдена, либо удалена',
      confirmDelete: 'Вы действительно хотите удалить данную заявку?',
      stageChangedInfo: stage => `Сообщите кандидатам о переводе их кандидатур на этап "${stage}" с помощью сообщения по электронной почте или видео-сообщения!`,
      stageChanged: 'Отлично!',
      close: 'Закрыть',
      reopenProcessConfirm: 'Вы действительно хотите перевести данного соискателя с этапа "Заявка снята" и вернуть его/её в процесс подбора сотрудника на данную вакансию? После подтверждения данный соискатель сможет снова отвечать на вопросы тех собеседований по данной вакансии, на которые соискатель ещё не внёс ответы полностью.',
      withdrawConfirm: 'Вы действительно хотите вывести данного соискателя из процесса подбора сотрудника на данную вакансию? После вывода соискатель не сможет отвечать на вопросы собеседований по данной вакансии, на которые ему/ей были отправлены приглашения.',
      changestageTooltip: 'Вы можете посмотреть на каком этапе найма находится каждый соискатель. Этап найма можно установить вручную, нажав нужный этап. Соискатели работы не получают уведомлений об изменении этапа.',
      commentsTooltip: 'Вы можете оставлять комментарии для ваших коллег по отдельно выбранному заявлению. Сами соискатели не имеют возможности видеть такие комментарии.',
      competencesTooltip: 'Можно ввести область компетенции, или оценить её уровень. Указанные вами области компетенции соискателей отображаются коллегам, которые могут оценивать их, а также вводить другие области компетенции. Соискателям данная информация не отображается.',
      actionlogTooltip: 'Здесь будут отображаться комментарии, изменения этапов найма, сообщения и прочие действия. Кандидату данная информация недоступна.',
      stage: {
        new: 'Новый',
        hired: 'Нанят',
        proceed: 'На рассмотрении',
        videointerviewed: 'Видеоинтервью',
        personalinterview: 'Персональное интервью',
        withdrawn: 'Заявка снята',
        scheduledinterview: 'Собеседование в назначенное время',
        rejected: 'Отказ',
      },
      state: {
        invited: 'Отправлено приглашение',
        visited: 'Было посещение',
        incomplete: 'Заполнение не зaкончено',
        completed: 'Заполнение зaкончено',
      },
      lastSeen: time => `Последнее время посещения ${time}.`,
      notVisited: 'Не проходил интервью.',
    },

    billing: {
      title: 'Оплата',
      nextPayment: (nextBillingPeriodAmount, nextBillingDate) => `Следующая сумма к оплате будет составлять ${nextBillingPeriodAmount} Евро ${nextBillingDate}`,
      status: 'Статус',
      singleHire: 'Разовая подписка',
      billingOverview: 'Обзор платежных данных',
      payment: 'Оплата',
      paymentHistory: 'История платежей',
      updateDetails: 'Обновление платежных данных',
      billingStatus: {
        pending: 'В обработке',
        active: 'Активная подписка',
        pastdue: 'Существует задолженность',
        expired: 'Подписка истекла',
        canceled: 'Отмена',
      },
      noContractsFound: 'No contracts found. Please contact customer support.',
      monthlyPrice: 'Monthly Price:',
      productName: 'Product Name:',
      products: 'Products',
      nextInvoiceDate: 'Next Invoice Date:',
      monthlyValue: 'Monthly Value:',
      invoiceFrequency: 'Invoice Frequency:',
      months: '(months)',
      nextInvoiceSum: 'Next Invoice Sum:',
      contractStatus: 'Contract Status:',
      contractStartDate: 'Contract Start Date:',
      contractEndDate: 'Contract End Date:',
      termOfNotice: 'Term of Notice:',
      contract: 'Contract',
    },

    candidate: {
      actionLog: 'Журнал действий',
      back: 'Вернуться к списку кандидатов',
      delete: 'Удалить кандидата',
      deleted: 'Кандидат удален',
      interviewClosed: 'Собеседование закрыто. Повторные приглашения не рассылались.',
      resendInvitation: 'Отправить приглашение кандидату повторно',
      changeStage: 'Перевести на другой этап',
      introducedTo: 'Представлен коллегам:',
      yourRatingText: 'Ваш рейтинг:',
      competencesAndCompatibility: 'Компетенции',
      duplicateCompetency: 'Компетенция уже существует',
      competencyNotFound: 'Компетенция не найдена, либо удалена',
      confirmDelete: 'Вы действительно хотите удалить данного соискателя?',
      stageChangedInfo: stage => `Сообщите кандидатам о переводе их кандидатур на этап "${stage}" с помощью сообщения по электронной почте или видео-сообщения!`,
      stageChanged: 'Отлично!',
      close: 'Закрыть',
      hideStages: 'Скрыть этапы',
      showStages: 'Показать этапы',
      resetQuestionResponseSuccess: 'Ответ кандидата удален',
      stage: {
        new: 'Новый',
        hired: 'Нанят',
        proceed: 'На рассмотрении',
        videointerviewed: 'Видеоинтервью',
        personalinterview: 'Персональное интервью',
        withdrawn: 'Заявка снята',
        scheduledinterview: 'Собеседование в назначенное время',
        rejected: 'Отказ',
      },
    },

    dashboard: {
      upcomingLiveInterviews: 'Интервью в режиме реального времени',
      showAllLiveInterviews: 'Показать все интервью в режиме реального времени',
      createNewLiveInterview: 'Создать новое интервью в режиме реального времени',
      welcome: name => `Добро пожаловать, ${name}!`,
      liveCard: {
        startTime: 'Время начала',
        interviewers: 'Интервьюеры',
        candidates: 'Кандидаты',
      },
    },

    interviewEdit: {
      title: 'Введите название интервью',
      titleLabel: 'Название собеседования',
      location: 'Местоположение',
      publishTimePlaceholder: 'Дата публикации',
      publishTimeTooltip: 'Установите дату открытия доступа к собеседованию. Дату можно изменить в любое время.',
      endTime: 'Крайний срок подачи заявок',
      endTimeTooltip: 'Выберите дату окончания времени подачи заявлений.',
      timezone: 'Часовой пояс',
      isNotPastDate: 'некорректная дата',
      interviewIsClosed: 'На данный момент собеседование закрыто. Хотите ли вы ',
      interviewIsClosedLink: 'открыть его',
      edit: {
        details: 'Редактировать интервью',
        status: 'Изменить статус интервью',
        team: 'Редактировать состав участников отбора',
      },
      questions: 'Вопросы интервью',
      answerable: 'Вопрос требует ответа',
      questionsDescription: 'Ниже Вы можете добавить вопросы, на которые должны будут ответить кандидаты.',
      questionsNotEditable: 'Вопросы не могут быть отредактированы после отправки приглашений.',
      saved: 'Интервью сохранено',
      deleted: 'Интервью удалено',
      delete: 'Удалить интервью',
      cancel: 'Отмена',
      save: 'Сохранить',
      language: 'Язык интервью',
      languagePlaceholder: 'Выбрать',
      languages: {
        en: 'English',
        fi: 'Finnish',
      },
      confirmLeave: 'У вас есть несохраненные изменения. Вы уверены, что хотите выйти?',
      OnboardingHeadImageSize: 'Рекомендуемые размеры заглавного баннера: 1440*320 точек или выше.',
      takeLimitLabel: 'Количество попыток',
      answerTimeLabel: 'Время на ответ',
      preparationTimeLabel: 'Время на подготовку',
      confirmHeader: 'Вы действительно хотите удалить данное собеседование?',
      integratedConfirmContent: 'Данное собеседование внедрено в другую систему. Его удаление может привести к проблемам с интеграцией.',
    },

    interview: {
      endTime: date => (date ? `до ${date}` : ''),
      edit: 'Редактировать интервью',
      copy: 'Копировать видеоинтервью',
      editInvitation: 'Редактировать сообщение с приглашением',
      editMenu: 'Редактировать',
      editTeam: 'Редактировать состав участников отбора',
      questions: 'Вопросы интервью',
      changeStatus: 'Изменить статус интервью',
      publishSettings: 'Настройки публикации',
      invite: 'Пригласить кандидатов',
      showCandidates: 'Показать кандидатов',
      oneError: ' Встроенное интервью может состоять только из одного вопроса.',
      copySuccess: 'Копия собеседования успешно создана',
      editIntroduceBatches: 'Редактировать представления',
      editEmailSettings: 'Редактировать настройки электронной почты',
    },

    interviews: {
      allInterviews: 'Все видеоинтервью',
      createNewVideoInterview: 'Создать новое видеоинтервью',
      filter: 'Поиск интервью',
      invites: 'Приглашения',
      responses: 'Ответы',
      sort: {
        title: 'Название',
        endTime: 'Дата окончания',
        publishTime: 'Дата публикации',
        createdAt: 'Дата создания',
        updatedAt: 'Последние изменения',
        answeredCount: 'Кандидаты',
      },
    },

    interviewCandidates: {
      preview: 'Предпросмотр',
      endTime: date => (date ? `Крайний срок подачи заявок ${date}` : ''),
      publicTitle: 'Публичное интервью',
      embedTitle: 'Встроенное интервью',
      placeholder: {
        first: 'На данный момент откликов нет. ',
        second: 'Вы можете сделать Ваше видеоинтервью общедоступным.',
        third: 'Тогда любой заинтересованный кандидат сможет увидеть интервью и откликнуться на вакансию.',
        fourth: 'И не забывайте, что все это всего в одном шаге от Вас, в строке заголовка выше.',
      },
      title: 'Все кандидаты',
      sort: {
        default: 'По умолчанию',
        updatedAt: 'По дате изменения',
        name: 'Имя',
        rating: 'Рейтинг',
        createdAt: 'Дата ',
      },
      sendMessage: 'Отправить сообщение',
      changeStage: 'Перевести на другой этап',
      introduce: 'Представить',
      filter: 'Искать кандидатов',
      hideFilters: 'Скрыть фильтры',
      showFilters: 'Показать фильтры',
      emailSent: 'Email отправлен!',
      interviewClosedError: 'Невозможно заново пригласить соискателя работы на видео-собеседование, которые было закрыто.',
      excel: 'Экспортировать всех кандидатов',
      reInviteSent: candidates => `Отправлено повторных приглашений: ${candidates}!`,
    },

    jobAdEdit: {
      preview: 'Предпросмотор',
      confirm: 'Вы уверены, что хотите добавить данную вакансию?',
      deleteHeader: 'Вы уверены, что хотите удалить данную вакансию?',
      deleteContent: 'Удаление данной вакансии также приведет к удалению всех сопутствующих данных, таких как заявления о приеме на работу и видеособеседования.',
      titlePlaceholder: 'Название вакансии',
      locationPlaceholder: 'Местоположение',
      timezone: 'Часовой пояс',
      endTimePlaceholder: 'Действительно до',
      endTimeTooltip: 'Выберите дату окончания времени подачи заявлений.',
      isNotPastDate: 'дата просрочена.',
      publishTimePlaceholder: 'Дата публикации',
      publishTimeTooltip: ' Установите дату публикации объявления о работе. Эту дату можно изменить в любое время. ',
      language: 'Язык',
      languagePlaceholder: 'Выбрать',
      languages: {
        en: 'English',
        fi: 'Finnish',
      },
      description: 'Описание вакансии',
      saved: 'Вакансия сохранена',
      deleted: 'Вакансия удалена',
      descriptionPlaceholder: 'Здесь Вы можете составить описание вакансии. \n\nПри необходимости воспользуйтесь панелью форматирования текста, расположенной выше.',
      createInviteOnly: 'Создать анонимное видеоинтервью, доступное только по приглашению',
      delete: 'Удалить',
      cancel: 'Отмена',
      save: 'Сохранить',
      confirmLeave: 'У Вас есть несохраненные изменения. Вы уверены, что хотите выйти?',
      singleHireEndError: 'Разовая подписка не может быть использована более 60 дней.',
      OnboardingHeadImageSize: 'Рекомендуемые размеры заглавного баннера: 1440*320 точек или выше.',
    },

    jobAdApplications: {
      endTime: date => (date ? `, действительно до ${date}` : ''),
      title: 'Все отклики',
      sort: {
        updatedAt: 'По дате изменения',
        name: 'По названию',
        rating: 'По рейтингу',
        createdAt: 'По дате создания',
      },
      add: 'Добавить нового кандидата',
      inviteToInterview: 'Пригласить на интервью',
      sendMessage: 'Отправить сообщение ',
      changeStage: 'Перевести на другой этап',
      introduce: 'Представить',
      editIntroduceBatches: 'Редактировать представления',
      addInterviewConfirm: jobAd => `Вы хотите создать новое видеоинтервью на вакансию "${jobAd}"?`,
      filter: 'Поиск откликов',
      hideFilters: 'Скрыть фильтры',
      showFilters: 'Показать фильтры',
    },

    adminJobAdApplication: {
      name: 'Имя',
      email: 'Email',
      phone: 'Телефон',
      city: 'Город',
      applyForPosition: 'Откликнуться на вакансию',
      back: 'Назад',
      continue: 'Продолжить',
      submit: 'Добавить',
      saveForLater: 'Продолжить позже',
      namePlaceholder: 'Имя и фамилия соискателя работы',
      emailPlaceholder: 'Введите адрес электронной почты кандидата',
      cityPlaceholder: 'Текущий город проживания соискателя работы',
      links: 'Здесь Вы можете добавить ссылки, например, на Вашу страницу в LinkedIn',
      legendLinks: 'Ссылки',
      legendAttachments: 'Вложения',
      legendAdditionalFields: 'Дополнительные данные',
      legendBasicInfo: 'Общие данные',
      coverLetter: 'Сопроводительное письмо',
      attachments: 'Вложения',
      introduction: 'Вы можете добавить свои комментарии здесь',
      readyInfo: 'Спасибо. Соискатель работы добавлен в список по данной вакансии.',
      close: 'Закрыть',
      required: 'Элементы, отмеченные звездочкой (*) обязательны для заполнения.',
      excel: 'Экспортировать все заявки',
    },

    jobAdPreview: {
      endTime: date => (date ? `, крайний срок подачи заявок ${date}` : ''),
      exit: 'Выйти из режима предпросмотра',
      description: 'Описание позиции',
      video: 'Корпоративное видео',
      questions: 'Видеовопрос',
      apply: 'Откликнуться',
    },

    jobAd: {
      endTime: date => (date ? `, крайний срок подачи заявок ${date}` : ''),
      changeStatus: 'Изменить статус вакансии',
      edit: 'Редактировать вакансию',
      copy: 'Копировать вакансию',
      editInvitation: 'Редактировать сообщение с приглашением',
      editTeam: 'Редактировать состав участников отбора',
      editMenu: 'Редактировать',
      description: 'Описание позиции',
      video: 'Корпоративное видео',
      questions: 'Видеовопрос',
      apply: 'Откликнуться',
      showApplications: 'Показать отклики',
      publicLink: 'Публичная страница вакансии',
      copySuccess: 'Копия вакансии успешно создана',
    },

    jobAds: {
      subscriptionNeeded: 'Для публикации вакансии Вам потребуется активная подписка.',
      responses: 'Отклики',
      createNewJobPosition: 'Создать новую вакансию',
      allJobPositions: 'Все вакансии',
      confirmSingleHire: 'Одна из приобретенных Вами разовых подписок используется для этой позиции.',
      filter: 'Поиск вакансий',
      sort: {
        title: 'Название',
        publishTime: 'Дата публикации',
        applicationCount: 'По числу откликов',
        endTime: 'По дате окончания',
        createdAt: 'По дате создания',
        updatedAt: 'Последние изменения',
      },
    },

    jobAdSaved: {
      title: 'Вакансия сохранена!',
      description: 'Ваша вакансия сохранена. Общедоступная ссылка на вакансию:',
      addApplication: 'Прямая ссылка на форму заявки:',
      toDashboard: 'Стартовая страница',
      toJobAd: 'Вернуться к вакансии',
    },

    live: {
      title: 'Интервью в режиме реального времени',
      editTitle: 'Редактировать собеседование, записанное в режиме прямого включения',
      startTimeTitle: 'Время начала интервью',
      startTime: 'Время начала',
      interviewers: 'Интервьюеры',
      candidates: 'Кандидаты',
      messageLabel: 'Приглашение',
      create: 'Создать',
      save: 'Сохранить изменения',
      cancel: 'Отмена',
      removeLive: 'Удалить интервью в режиме реального времени',
      cancelLive: 'Отменить интервью в режиме реального времени',
      comment: 'Добавить новый комментарий',
      commentLabel: 'Комментарии',
      enter: 'Присоединиться к интервью в режиме реального времени',
      edit: 'Добавить/удалить участников',
      draft: 'Новое интервью в режиме реального времени',
      confirmHeader: 'Вы действительно хотите удалить данное собеседование?',
      inviteFailure: (success, failed) => `${success} приглашений отправлено и ${failed} не удалась!`,
      inviteSuccess: success => `${success} приглашений отправлено.`,
      success: {
        create: 'Интервью в режиме реального времени создано',
        delete: 'Интервью в режиме реального времени удалено',
        update: 'Интервью в режиме реального времени обновлено',
      },
      placeholders: {
        candidateEmails: 'Добавить кандидата',
        interviewerEmails: 'Добавить интервьюера',
        emailTitle: 'Заголовок',
        emailMessage: 'Сообщение',
      },
    },

    lives: {
      allLives: 'Все интервью в режиме реального времени',
      createNewLive: 'Создать новое интервью в режиме реального времени',
      filter: 'Поиск по кандидатам',
      candidates: 'Кандидаты',
      sort: {
        title: 'Заголовок',
        startTime: 'Время начала',
        createdAt: 'Дата создания',
      },
    },

    login: {
      title: 'Авторизация',
      register: 'Регистрация',
      ldap: 'Авторизация с LDAP интеграцией',
      forgot: 'Забыли пароль?',
      normal: 'Стандартная авторизация',
      ssoLogin: 'Единый вход в систему (SSO)',
    },

    publicSubscribe: {
      intro: 'Выберите подходящий тарифный план, заполните детали оплаты и приступайте к использованию сервиса. Все Ваши платежи безопасно обрабатываются в системе Braintree.',
      headline: 'Форма подписки',
      header: {
        back: 'Back',
      },
      footer: {
        product: 'Product',
        pricing: 'Pricing',
        resources: 'Resources',
        contact: 'Contact',
        terms: 'User Terms and Conditions',
        privacyPolicy: 'Privacy policy',
        license: 'General Terms of Service',
      },
    },

    publicSubscribeThankYou: {
      title: 'Спасибо!',
      existingDescription: 'Мы получили Вашу информацию о подписке, теперь Вы можете продолжить использование видеоинтервью.',
      newUserDescription: 'Мы создали учетную запись для Вас и отправили Вам информацию по установке пароля по электронной почте.',
    },

    quickInterview: {
      title: 'Быстрое видеоинтервью',
      description: 'Чтобы быстрее узнать Вас, мы бы хотели, чтобы Вы кратко ответили на наш вопрос. Постарайтесь проявить свою индивидуальность.',
      requiredNote: 'Обратите внимание, что это лишь одна из частей процесса подачи заявки, и рекрутер получит Вашу заявку только после того, как Вы запишете свой ответ.',
      reminderNote: 'Вы можете записать ответ сейчас, или продолжить позже, получив напоминание на свой адрес электронной почты.',
    },

    register: {
      title: 'Разработано для рекрутеров!',
      leadText: 'Recright – видео-платформа для набора кадров, разработанная для рекрутеров и специалистов по набору кадров. Платформа позволяет публиковать открытые вакансии, принимать заявления и проводить видео-собеседования – и всё это в одном и том же месте! Мы помогли более чем 400 компаниям найти нужных сотрудников, и ваша компания может стать следующей! Зарегистрируйтесь и начните набор кадров!',
      email: 'Email',
      submit: 'Зарегистрироваться',
      alreadyMember: 'Уже зарегистрированы?',
      onlyForRecruiters: 'Регистрация предназначена исключительно для рекрутеров и специалистов по набору кадров.',
      login: 'Авторизуйтесь здесь.',
      registerSuccess: 'Проверьте свою электронную почту и завершите регистрацию, перейдя по присланной ссылке.',
      domainError: 'Зарегистрируйтесь на свой корпоративный адрес электронной почты.',
      companyExistsMessage: 'Проверьте свою электронную почту для дальнейших инструкций!',
    },

    searchResults: {
      title: 'Результаты поиска',
      applications: 'Заявки',
      candidates: 'Кандидаты',
      noApplications: 'Нет заявок, соответствующих критериям поиска',
      noCandidates: 'Нет кандидатов, соответствующих критериям поиска',
      query: query => (query ? `Поисковый запрос: ${query}` : ''),
      noStage: 'без статуса',
      search: 'Поиск',
      itemsPerPage: 'Items per page',
    },

    statistics: {
      linkToDetailed: 'See detailed statistics',
      linkToSummary: 'See statistics summary',
      summaryLeadText: 'Figures below comprises of all active positions during the selected time period including the positions that do not have an end date.',
      detailsLeadText: 'This page provides detailed statistics on all positions with any activity during the selected time period.',
      export: 'Export statistics',
      sort: {
        title: 'Заголовок',
        owner: 'Owner',
        createdAt: 'Дата создания',
      },
      exportLimit:
        'Too many results. Please reduce the timeframe to enable excel export.',
      tooManyResults:
        'Too many results. Please reduce the timeframe to get results.',
    },

    forgotPassword: {
      title: 'Установка нового пароля',
      email: 'Email',
      submit: 'Отправить',
      sendEmail: 'Отправьте нам адрес электронной почты, который вы использовали при регистрации на Recright.',
      instructions: 'Мы направим Вам инструкции по изменению пароля.',
      success: 'Если пользователь с указанным адресом электронной почты найден в системе, то инструкции по смену пароля были отправлены на указанный адрес.',
    },

    changePassword: {
      title: 'Установка нового пароля',
      name: 'Имя',
      email: 'Email',
      password: 'Новый пароль',
      confirmPassword: 'Повторите новый пароль',
      submit: 'Изменить пароль',
      error: {
        password: {
          isRequired: 'Необходимо ввести пароль.',
          isValidPassword: 'В пароле должна быть как минимум одна заглавная буква, одна прописная буква и одна цифра. Длина пароля – минимум 12 символов.',
          passwordsMatch: 'Пароли не совпадают.',
        },
      },
    },

    ssoLogin: {
      title: 'Единый вход в систему (SSO)',
      description: 'Войдите в систему с помощью учётных данных своей организации.',
      info: 'Внешняя аутентификация не настроена. Используйте',
      normalLoginLinkText: 'обычный способ входа в систему.',
      submit: 'Авторизоваться',
    },

    welcome: {
      title: 'Регистрация',
    },

    welcomeMulticompany: {
      welcome: companyName => `Добро пожаловать в ${companyName}`,
      successMessage: companyName =>
        `Вы были добавлены в организацию ${companyName}!`,
      navigationInfo:
        'Вы можете изменить вашу текущую организацию в настройках в верхнем правом углу.',
      login: 'Авторизуйтесь здесь',
    },

    subscribe: {
      title: 'Подписка',
      submit: 'Подписаться',
      creditCard: 'Номер карты',
      cvv: 'CVV',
      expirationDate: 'Срок действия карты',
      vatAdvice: 'При предоставлении номера плательщика НДС, налог на добавочную стоимость не будет добавляться к сумме заказа.',
      vatId: 'Идентификатор НДС / налога',
      vatHelp: 'Укажите идентификатор НДС в международном формате, включая код страны.',
      includeVat: 'вкл. НДС',
      firstName: 'Имя',
      lastName: 'Фамилия',
      email: 'Email',
      company: 'Компания',
      street: 'Улица',
      postalCode: 'Индекс',
      city: 'Город',
      country: 'Страна',
      emptyCardFields: 'Пожалуйста, заполните данные своей кредитной карты.',
      invalidValue: 'Значение поля недействительно..',
      planNotSelected: 'Выберите план',
      totalPrice: 'Итого',
      subscribed: 'Замечательно! Ваша подписка создана.',
      subscriptionExists: 'У Вашей компании есть активная подписка. Войдите, чтобы изменить подписку.',
      agreeTos: 'Мной прочитано и одобрено ',
      agreeTosLinkText: 'Условия и положения для пользователей Recright.',
      privacyPolicy: 'Мы ценим вашу конфиденциальность. Пожалуйста, ознакомьтесь с нашей ',
      privacyPolicyLinkText: 'Политика конфиденциальности.',
      licenseAgreement: 'От имени представляемой мной организации я принимаю ',
      licenseAgreementLinkText: 'Общие условия оказания услуг Recright.',
      newsletter: 'Подписаться на ежемесячную рассылку.',
      neverExpiresDiscount: amount => `Включая постоянную скидку${amount}`,
      fixedPeriodDiscount: (amount, cycles) => `Включая скидку ${amount} на ${cycles} месяцев`,
      errorFromProcessor: error => `Платёжная система выдала ошибку: ${error}`,
    },

    videos: {
      title: 'Видеотека',
      add: 'Создать новое видео',
      rename: 'Переименовать',
      remove: 'Удалить',
      yourVideos: 'Ваши видеоролики',
      companyVideos: 'Видеоролики компании',
      sort: {
        createdAt: 'Дата создания',
        title: 'Заголовок',
      },

    },

    userManagement: {
      excel: 'Экспортировать всех пользователей',
      title: 'Управление пользователями',
      showCompanyDefaultPermissions: 'Показать стандартные права доступа компании',
      activateUserConfirm: 'Вы уверены, что хотите активировать данного пользователя?',
      deactivateUserConfirm: 'Вы уверены, что хотите деактивировать данного пользователя?',
      showActivatedUsers: 'Показать активных пользователей',
      showDeactivatedUsers: 'Показать неактивных пользователей',
      confirmCancelEditPermissions: {
        message: 'У вас есть несохраненные изменения. Действительно сбросить все изменения?',
        cancel: 'Отменить',
        confirm: 'Сбросить изменения',
      },
      unsavedChanges: 'У вас есть несохраненные изменения. Хотите сохранить их?',
      confirm: 'Сохранить',
      permissionsChangesSaved: 'Права доступа пользователей успешно изменены!',
      userDeactivated: nameOrEmail => `${nameOrEmail} деактивирован`,
      userActivated: nameOrEmail => `${nameOrEmail} активирован`,
      companyDefaultsSaved: 'Права доступа администратора по умолчанию успешно изменены!',
      usersAddAdded: success => `${success} пользователя (-ей) добавлено.`,
      usersAddExist: exist => ` ${exist} пользователя (-ей) уже зарегистрированы в Recright.`,
      excel: 'Экспортировать всех пользователей',
    },

  },

}
